// @generated by protobuf-ts 2.11.1 with parameter output_javascript
// @generated from protobuf file "analytics.proto" (package "kalos.analytics.v1", syntax proto3)
// tslint:disable
// @generated by protobuf-ts 2.11.1 with parameter output_javascript
// @generated from protobuf file "analytics.proto" (package "kalos.analytics.v1", syntax proto3)
// tslint:disable
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { WireType } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { SellSheet } from "./quote";
// @generated message type with reflection information, may provide speed optimized methods
class DateRangeFilter$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.DateRangeFilter", [
            { no: 1, name: "start_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "end_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.startDate = "";
        message.endDate = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string start_date */ 1:
                    message.startDate = reader.string();
                    break;
                case /* string end_date */ 2:
                    message.endDate = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string start_date = 1; */
        if (message.startDate !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.startDate);
        /* string end_date = 2; */
        if (message.endDate !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.endDate);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.DateRangeFilter
 */
export const DateRangeFilter = new DateRangeFilter$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StandardMetricsFilter$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.StandardMetricsFilter", [
            { no: 1, name: "date_range", kind: "message", T: () => DateRangeFilter },
            { no: 2, name: "is_residential", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "is_commercial", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "department_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "job_type_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "technician_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "department_list", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "customer_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "event_trade_list", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.isResidential = false;
        message.isCommercial = false;
        message.departmentId = 0;
        message.jobTypeId = 0;
        message.technicianId = 0;
        message.departmentList = "";
        message.customerId = 0;
        message.eventTradeList = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* kalos.analytics.v1.DateRangeFilter date_range */ 1:
                    message.dateRange = DateRangeFilter.internalBinaryRead(reader, reader.uint32(), options, message.dateRange);
                    break;
                case /* bool is_residential */ 2:
                    message.isResidential = reader.bool();
                    break;
                case /* bool is_commercial */ 3:
                    message.isCommercial = reader.bool();
                    break;
                case /* int32 department_id */ 4:
                    message.departmentId = reader.int32();
                    break;
                case /* int32 job_type_id */ 5:
                    message.jobTypeId = reader.int32();
                    break;
                case /* int32 technician_id */ 6:
                    message.technicianId = reader.int32();
                    break;
                case /* string department_list */ 7:
                    message.departmentList = reader.string();
                    break;
                case /* int32 customer_id */ 8:
                    message.customerId = reader.int32();
                    break;
                case /* string event_trade_list */ 9:
                    message.eventTradeList = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* kalos.analytics.v1.DateRangeFilter date_range = 1; */
        if (message.dateRange)
            DateRangeFilter.internalBinaryWrite(message.dateRange, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool is_residential = 2; */
        if (message.isResidential !== false)
            writer.tag(2, WireType.Varint).bool(message.isResidential);
        /* bool is_commercial = 3; */
        if (message.isCommercial !== false)
            writer.tag(3, WireType.Varint).bool(message.isCommercial);
        /* int32 department_id = 4; */
        if (message.departmentId !== 0)
            writer.tag(4, WireType.Varint).int32(message.departmentId);
        /* int32 job_type_id = 5; */
        if (message.jobTypeId !== 0)
            writer.tag(5, WireType.Varint).int32(message.jobTypeId);
        /* int32 technician_id = 6; */
        if (message.technicianId !== 0)
            writer.tag(6, WireType.Varint).int32(message.technicianId);
        /* string department_list = 7; */
        if (message.departmentList !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.departmentList);
        /* int32 customer_id = 8; */
        if (message.customerId !== 0)
            writer.tag(8, WireType.Varint).int32(message.customerId);
        /* string event_trade_list = 9; */
        if (message.eventTradeList !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.eventTradeList);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.StandardMetricsFilter
 */
export const StandardMetricsFilter = new StandardMetricsFilter$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PaginationRequest$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.PaginationRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "sort_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "sort_desc", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.pageSize = 0;
        message.pageNumber = 0;
        message.sortBy = "";
        message.sortDesc = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* int32 page_number */ 2:
                    message.pageNumber = reader.int32();
                    break;
                case /* string sort_by */ 3:
                    message.sortBy = reader.string();
                    break;
                case /* bool sort_desc */ 4:
                    message.sortDesc = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* int32 page_number = 2; */
        if (message.pageNumber !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageNumber);
        /* string sort_by = 3; */
        if (message.sortBy !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.sortBy);
        /* bool sort_desc = 4; */
        if (message.sortDesc !== false)
            writer.tag(4, WireType.Varint).bool(message.sortDesc);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.PaginationRequest
 */
export const PaginationRequest = new PaginationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PaginationResponse$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.PaginationResponse", [
            { no: 1, name: "total_records", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "total_pages", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "current_page", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.totalRecords = 0;
        message.totalPages = 0;
        message.currentPage = 0;
        message.pageSize = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 total_records */ 1:
                    message.totalRecords = reader.int32();
                    break;
                case /* int32 total_pages */ 2:
                    message.totalPages = reader.int32();
                    break;
                case /* int32 current_page */ 3:
                    message.currentPage = reader.int32();
                    break;
                case /* int32 page_size */ 4:
                    message.pageSize = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 total_records = 1; */
        if (message.totalRecords !== 0)
            writer.tag(1, WireType.Varint).int32(message.totalRecords);
        /* int32 total_pages = 2; */
        if (message.totalPages !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalPages);
        /* int32 current_page = 3; */
        if (message.currentPage !== 0)
            writer.tag(3, WireType.Varint).int32(message.currentPage);
        /* int32 page_size = 4; */
        if (message.pageSize !== 0)
            writer.tag(4, WireType.Varint).int32(message.pageSize);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.PaginationResponse
 */
export const PaginationResponse = new PaginationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TimeSeriesData$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.TimeSeriesData", [
            { no: 1, name: "date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "value", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "metadata", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ } }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.date = "";
        message.value = 0;
        message.metadata = {};
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string date */ 1:
                    message.date = reader.string();
                    break;
                case /* double value */ 2:
                    message.value = reader.double();
                    break;
                case /* map<string, string> metadata */ 3:
                    this.binaryReadMap3(message.metadata, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    binaryReadMap3(map, reader, options) {
        let len = reader.uint32(), end = reader.pos + len, key, val;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for kalos.analytics.v1.TimeSeriesData.metadata");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message, writer, options) {
        /* string date = 1; */
        if (message.date !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.date);
        /* double value = 2; */
        if (message.value !== 0)
            writer.tag(2, WireType.Bit64).double(message.value);
        /* map<string, string> metadata = 3; */
        for (let k of globalThis.Object.keys(message.metadata))
            writer.tag(3, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.metadata[k]).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.TimeSeriesData
 */
export const TimeSeriesData = new TimeSeriesData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FinancialTimePeriod$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.FinancialTimePeriod", [
            { no: 1, name: "period_label", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "year", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "quarter", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "revenue", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "gross_profit", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "gross_margin_pct", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 7, name: "job_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.periodLabel = "";
        message.year = 0;
        message.quarter = 0;
        message.revenue = 0;
        message.grossProfit = 0;
        message.grossMarginPct = 0;
        message.jobCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string period_label */ 1:
                    message.periodLabel = reader.string();
                    break;
                case /* int32 year */ 2:
                    message.year = reader.int32();
                    break;
                case /* int32 quarter */ 3:
                    message.quarter = reader.int32();
                    break;
                case /* double revenue */ 4:
                    message.revenue = reader.double();
                    break;
                case /* double gross_profit */ 5:
                    message.grossProfit = reader.double();
                    break;
                case /* double gross_margin_pct */ 6:
                    message.grossMarginPct = reader.double();
                    break;
                case /* int32 job_count */ 7:
                    message.jobCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string period_label = 1; */
        if (message.periodLabel !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.periodLabel);
        /* int32 year = 2; */
        if (message.year !== 0)
            writer.tag(2, WireType.Varint).int32(message.year);
        /* int32 quarter = 3; */
        if (message.quarter !== 0)
            writer.tag(3, WireType.Varint).int32(message.quarter);
        /* double revenue = 4; */
        if (message.revenue !== 0)
            writer.tag(4, WireType.Bit64).double(message.revenue);
        /* double gross_profit = 5; */
        if (message.grossProfit !== 0)
            writer.tag(5, WireType.Bit64).double(message.grossProfit);
        /* double gross_margin_pct = 6; */
        if (message.grossMarginPct !== 0)
            writer.tag(6, WireType.Bit64).double(message.grossMarginPct);
        /* int32 job_count = 7; */
        if (message.jobCount !== 0)
            writer.tag(7, WireType.Varint).int32(message.jobCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.FinancialTimePeriod
 */
export const FinancialTimePeriod = new FinancialTimePeriod$Type();
// @generated message type with reflection information, may provide speed optimized methods
class JobProfitabilityItem$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.JobProfitabilityItem", [
            { no: 1, name: "job_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "job_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "start_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "customer_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "department_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "job_type_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "total_cost", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 8, name: "revenue", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 9, name: "gross_profit", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 10, name: "margin_percentage", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 11, name: "dollars_per_hour", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 12, name: "billable_hours", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 13, name: "technician", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "event_trade_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 15, name: "trade_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.jobId = 0;
        message.jobNumber = "";
        message.startDate = "";
        message.customerName = "";
        message.departmentName = "";
        message.jobTypeName = "";
        message.totalCost = 0;
        message.revenue = 0;
        message.grossProfit = 0;
        message.marginPercentage = 0;
        message.dollarsPerHour = 0;
        message.billableHours = 0;
        message.technician = "";
        message.eventTradeId = 0;
        message.tradeName = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 job_id */ 1:
                    message.jobId = reader.int32();
                    break;
                case /* string job_number */ 2:
                    message.jobNumber = reader.string();
                    break;
                case /* string start_date */ 3:
                    message.startDate = reader.string();
                    break;
                case /* string customer_name */ 4:
                    message.customerName = reader.string();
                    break;
                case /* string department_name */ 5:
                    message.departmentName = reader.string();
                    break;
                case /* string job_type_name */ 6:
                    message.jobTypeName = reader.string();
                    break;
                case /* double total_cost */ 7:
                    message.totalCost = reader.double();
                    break;
                case /* double revenue */ 8:
                    message.revenue = reader.double();
                    break;
                case /* double gross_profit */ 9:
                    message.grossProfit = reader.double();
                    break;
                case /* double margin_percentage */ 10:
                    message.marginPercentage = reader.double();
                    break;
                case /* double dollars_per_hour */ 11:
                    message.dollarsPerHour = reader.double();
                    break;
                case /* double billable_hours */ 12:
                    message.billableHours = reader.double();
                    break;
                case /* string technician */ 13:
                    message.technician = reader.string();
                    break;
                case /* int32 event_trade_id */ 14:
                    message.eventTradeId = reader.int32();
                    break;
                case /* string trade_name */ 15:
                    message.tradeName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 job_id = 1; */
        if (message.jobId !== 0)
            writer.tag(1, WireType.Varint).int32(message.jobId);
        /* string job_number = 2; */
        if (message.jobNumber !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.jobNumber);
        /* string start_date = 3; */
        if (message.startDate !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.startDate);
        /* string customer_name = 4; */
        if (message.customerName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.customerName);
        /* string department_name = 5; */
        if (message.departmentName !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.departmentName);
        /* string job_type_name = 6; */
        if (message.jobTypeName !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.jobTypeName);
        /* double total_cost = 7; */
        if (message.totalCost !== 0)
            writer.tag(7, WireType.Bit64).double(message.totalCost);
        /* double revenue = 8; */
        if (message.revenue !== 0)
            writer.tag(8, WireType.Bit64).double(message.revenue);
        /* double gross_profit = 9; */
        if (message.grossProfit !== 0)
            writer.tag(9, WireType.Bit64).double(message.grossProfit);
        /* double margin_percentage = 10; */
        if (message.marginPercentage !== 0)
            writer.tag(10, WireType.Bit64).double(message.marginPercentage);
        /* double dollars_per_hour = 11; */
        if (message.dollarsPerHour !== 0)
            writer.tag(11, WireType.Bit64).double(message.dollarsPerHour);
        /* double billable_hours = 12; */
        if (message.billableHours !== 0)
            writer.tag(12, WireType.Bit64).double(message.billableHours);
        /* string technician = 13; */
        if (message.technician !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.technician);
        /* int32 event_trade_id = 14; */
        if (message.eventTradeId !== 0)
            writer.tag(14, WireType.Varint).int32(message.eventTradeId);
        /* string trade_name = 15; */
        if (message.tradeName !== "")
            writer.tag(15, WireType.LengthDelimited).string(message.tradeName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.JobProfitabilityItem
 */
export const JobProfitabilityItem = new JobProfitabilityItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TechnicianPerformanceRequest$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.TechnicianPerformanceRequest", [
            { no: 1, name: "filter", kind: "message", T: () => StandardMetricsFilter },
            { no: 2, name: "pagination", kind: "message", T: () => PaginationRequest },
            { no: 3, name: "search_text", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.searchText = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* kalos.analytics.v1.StandardMetricsFilter filter */ 1:
                    message.filter = StandardMetricsFilter.internalBinaryRead(reader, reader.uint32(), options, message.filter);
                    break;
                case /* kalos.analytics.v1.PaginationRequest pagination */ 2:
                    message.pagination = PaginationRequest.internalBinaryRead(reader, reader.uint32(), options, message.pagination);
                    break;
                case /* string search_text */ 3:
                    message.searchText = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* kalos.analytics.v1.StandardMetricsFilter filter = 1; */
        if (message.filter)
            StandardMetricsFilter.internalBinaryWrite(message.filter, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* kalos.analytics.v1.PaginationRequest pagination = 2; */
        if (message.pagination)
            PaginationRequest.internalBinaryWrite(message.pagination, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string search_text = 3; */
        if (message.searchText !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.searchText);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.TechnicianPerformanceRequest
 */
export const TechnicianPerformanceRequest = new TechnicianPerformanceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TechnicianPerformanceResponse$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.TechnicianPerformanceResponse", [
            { no: 1, name: "technicians", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TechnicianPerformanceItem },
            { no: 2, name: "pagination", kind: "message", T: () => PaginationResponse },
            { no: 3, name: "average_revenue", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "average_utilization", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "calculated_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "departments", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TechnicianDepartmentBreakdown }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.technicians = [];
        message.averageRevenue = 0;
        message.averageUtilization = 0;
        message.calculatedAt = "";
        message.departments = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated kalos.analytics.v1.TechnicianPerformanceItem technicians */ 1:
                    message.technicians.push(TechnicianPerformanceItem.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* kalos.analytics.v1.PaginationResponse pagination */ 2:
                    message.pagination = PaginationResponse.internalBinaryRead(reader, reader.uint32(), options, message.pagination);
                    break;
                case /* double average_revenue */ 3:
                    message.averageRevenue = reader.double();
                    break;
                case /* double average_utilization */ 4:
                    message.averageUtilization = reader.double();
                    break;
                case /* string calculated_at */ 5:
                    message.calculatedAt = reader.string();
                    break;
                case /* repeated kalos.analytics.v1.TechnicianDepartmentBreakdown departments */ 6:
                    message.departments.push(TechnicianDepartmentBreakdown.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated kalos.analytics.v1.TechnicianPerformanceItem technicians = 1; */
        for (let i = 0; i < message.technicians.length; i++)
            TechnicianPerformanceItem.internalBinaryWrite(message.technicians[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* kalos.analytics.v1.PaginationResponse pagination = 2; */
        if (message.pagination)
            PaginationResponse.internalBinaryWrite(message.pagination, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* double average_revenue = 3; */
        if (message.averageRevenue !== 0)
            writer.tag(3, WireType.Bit64).double(message.averageRevenue);
        /* double average_utilization = 4; */
        if (message.averageUtilization !== 0)
            writer.tag(4, WireType.Bit64).double(message.averageUtilization);
        /* string calculated_at = 5; */
        if (message.calculatedAt !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.calculatedAt);
        /* repeated kalos.analytics.v1.TechnicianDepartmentBreakdown departments = 6; */
        for (let i = 0; i < message.departments.length; i++)
            TechnicianDepartmentBreakdown.internalBinaryWrite(message.departments[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.TechnicianPerformanceResponse
 */
export const TechnicianPerformanceResponse = new TechnicianPerformanceResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TechnicianPerformanceItem$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.TechnicianPerformanceItem", [
            { no: 1, name: "technician_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "technician_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "department_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "revenue", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "average_job_value", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "callback_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "billable_hours", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 8, name: "non_billable_hours", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 9, name: "utilization_percentage", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 10, name: "total_jobs", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "total_drive_time_hours", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 12, name: "average_drive_time_minutes", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 13, name: "overtime_hours", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 14, name: "unplanned_time_off_hours", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 15, name: "travel_expenses", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 16, name: "average_time_on_site_hours", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 17, name: "sell_sheets_created", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 18, name: "spiffs_approved", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 19, name: "gross_profit_margin_percentage", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 20, name: "maintenance_gpm", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 21, name: "service_gpm", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 22, name: "repair_gpm", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 23, name: "addon_gpm", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 24, name: "event_trade_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 25, name: "trade_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.technicianId = 0;
        message.technicianName = "";
        message.departmentName = "";
        message.revenue = 0;
        message.averageJobValue = 0;
        message.callbackCount = 0;
        message.billableHours = 0;
        message.nonBillableHours = 0;
        message.utilizationPercentage = 0;
        message.totalJobs = 0;
        message.totalDriveTimeHours = 0;
        message.averageDriveTimeMinutes = 0;
        message.overtimeHours = 0;
        message.unplannedTimeOffHours = 0;
        message.travelExpenses = 0;
        message.averageTimeOnSiteHours = 0;
        message.sellSheetsCreated = 0;
        message.spiffsApproved = 0;
        message.grossProfitMarginPercentage = 0;
        message.maintenanceGpm = 0;
        message.serviceGpm = 0;
        message.repairGpm = 0;
        message.addonGpm = 0;
        message.eventTradeId = 0;
        message.tradeName = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 technician_id */ 1:
                    message.technicianId = reader.int32();
                    break;
                case /* string technician_name */ 2:
                    message.technicianName = reader.string();
                    break;
                case /* string department_name */ 3:
                    message.departmentName = reader.string();
                    break;
                case /* double revenue */ 4:
                    message.revenue = reader.double();
                    break;
                case /* double average_job_value */ 5:
                    message.averageJobValue = reader.double();
                    break;
                case /* int32 callback_count */ 6:
                    message.callbackCount = reader.int32();
                    break;
                case /* double billable_hours */ 7:
                    message.billableHours = reader.double();
                    break;
                case /* double non_billable_hours */ 8:
                    message.nonBillableHours = reader.double();
                    break;
                case /* double utilization_percentage */ 9:
                    message.utilizationPercentage = reader.double();
                    break;
                case /* int32 total_jobs */ 10:
                    message.totalJobs = reader.int32();
                    break;
                case /* double total_drive_time_hours */ 11:
                    message.totalDriveTimeHours = reader.double();
                    break;
                case /* double average_drive_time_minutes */ 12:
                    message.averageDriveTimeMinutes = reader.double();
                    break;
                case /* double overtime_hours */ 13:
                    message.overtimeHours = reader.double();
                    break;
                case /* double unplanned_time_off_hours */ 14:
                    message.unplannedTimeOffHours = reader.double();
                    break;
                case /* double travel_expenses */ 15:
                    message.travelExpenses = reader.double();
                    break;
                case /* double average_time_on_site_hours */ 16:
                    message.averageTimeOnSiteHours = reader.double();
                    break;
                case /* int32 sell_sheets_created */ 17:
                    message.sellSheetsCreated = reader.int32();
                    break;
                case /* int32 spiffs_approved */ 18:
                    message.spiffsApproved = reader.int32();
                    break;
                case /* double gross_profit_margin_percentage */ 19:
                    message.grossProfitMarginPercentage = reader.double();
                    break;
                case /* double maintenance_gpm */ 20:
                    message.maintenanceGpm = reader.double();
                    break;
                case /* double service_gpm */ 21:
                    message.serviceGpm = reader.double();
                    break;
                case /* double repair_gpm */ 22:
                    message.repairGpm = reader.double();
                    break;
                case /* double addon_gpm */ 23:
                    message.addonGpm = reader.double();
                    break;
                case /* int32 event_trade_id */ 24:
                    message.eventTradeId = reader.int32();
                    break;
                case /* string trade_name */ 25:
                    message.tradeName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 technician_id = 1; */
        if (message.technicianId !== 0)
            writer.tag(1, WireType.Varint).int32(message.technicianId);
        /* string technician_name = 2; */
        if (message.technicianName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.technicianName);
        /* string department_name = 3; */
        if (message.departmentName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.departmentName);
        /* double revenue = 4; */
        if (message.revenue !== 0)
            writer.tag(4, WireType.Bit64).double(message.revenue);
        /* double average_job_value = 5; */
        if (message.averageJobValue !== 0)
            writer.tag(5, WireType.Bit64).double(message.averageJobValue);
        /* int32 callback_count = 6; */
        if (message.callbackCount !== 0)
            writer.tag(6, WireType.Varint).int32(message.callbackCount);
        /* double billable_hours = 7; */
        if (message.billableHours !== 0)
            writer.tag(7, WireType.Bit64).double(message.billableHours);
        /* double non_billable_hours = 8; */
        if (message.nonBillableHours !== 0)
            writer.tag(8, WireType.Bit64).double(message.nonBillableHours);
        /* double utilization_percentage = 9; */
        if (message.utilizationPercentage !== 0)
            writer.tag(9, WireType.Bit64).double(message.utilizationPercentage);
        /* int32 total_jobs = 10; */
        if (message.totalJobs !== 0)
            writer.tag(10, WireType.Varint).int32(message.totalJobs);
        /* double total_drive_time_hours = 11; */
        if (message.totalDriveTimeHours !== 0)
            writer.tag(11, WireType.Bit64).double(message.totalDriveTimeHours);
        /* double average_drive_time_minutes = 12; */
        if (message.averageDriveTimeMinutes !== 0)
            writer.tag(12, WireType.Bit64).double(message.averageDriveTimeMinutes);
        /* double overtime_hours = 13; */
        if (message.overtimeHours !== 0)
            writer.tag(13, WireType.Bit64).double(message.overtimeHours);
        /* double unplanned_time_off_hours = 14; */
        if (message.unplannedTimeOffHours !== 0)
            writer.tag(14, WireType.Bit64).double(message.unplannedTimeOffHours);
        /* double travel_expenses = 15; */
        if (message.travelExpenses !== 0)
            writer.tag(15, WireType.Bit64).double(message.travelExpenses);
        /* double average_time_on_site_hours = 16; */
        if (message.averageTimeOnSiteHours !== 0)
            writer.tag(16, WireType.Bit64).double(message.averageTimeOnSiteHours);
        /* int32 sell_sheets_created = 17; */
        if (message.sellSheetsCreated !== 0)
            writer.tag(17, WireType.Varint).int32(message.sellSheetsCreated);
        /* int32 spiffs_approved = 18; */
        if (message.spiffsApproved !== 0)
            writer.tag(18, WireType.Varint).int32(message.spiffsApproved);
        /* double gross_profit_margin_percentage = 19; */
        if (message.grossProfitMarginPercentage !== 0)
            writer.tag(19, WireType.Bit64).double(message.grossProfitMarginPercentage);
        /* double maintenance_gpm = 20; */
        if (message.maintenanceGpm !== 0)
            writer.tag(20, WireType.Bit64).double(message.maintenanceGpm);
        /* double service_gpm = 21; */
        if (message.serviceGpm !== 0)
            writer.tag(21, WireType.Bit64).double(message.serviceGpm);
        /* double repair_gpm = 22; */
        if (message.repairGpm !== 0)
            writer.tag(22, WireType.Bit64).double(message.repairGpm);
        /* double addon_gpm = 23; */
        if (message.addonGpm !== 0)
            writer.tag(23, WireType.Bit64).double(message.addonGpm);
        /* int32 event_trade_id = 24; */
        if (message.eventTradeId !== 0)
            writer.tag(24, WireType.Varint).int32(message.eventTradeId);
        /* string trade_name = 25; */
        if (message.tradeName !== "")
            writer.tag(25, WireType.LengthDelimited).string(message.tradeName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.TechnicianPerformanceItem
 */
export const TechnicianPerformanceItem = new TechnicianPerformanceItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TechnicianDepartmentBreakdown$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.TechnicianDepartmentBreakdown", [
            { no: 1, name: "department_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "department_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "technician_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "total_revenue", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "average_revenue_per_technician", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "total_billable_hours", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 7, name: "average_utilization", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 8, name: "total_jobs", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "average_jobs_per_technician", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 10, name: "total_callbacks", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "callback_rate", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 12, name: "gross_profit_margin_percentage", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 13, name: "job_type_breakdown", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => DepartmentJobTypeBreakdown }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.departmentId = 0;
        message.departmentName = "";
        message.technicianCount = 0;
        message.totalRevenue = 0;
        message.averageRevenuePerTechnician = 0;
        message.totalBillableHours = 0;
        message.averageUtilization = 0;
        message.totalJobs = 0;
        message.averageJobsPerTechnician = 0;
        message.totalCallbacks = 0;
        message.callbackRate = 0;
        message.grossProfitMarginPercentage = 0;
        message.jobTypeBreakdown = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 department_id */ 1:
                    message.departmentId = reader.int32();
                    break;
                case /* string department_name */ 2:
                    message.departmentName = reader.string();
                    break;
                case /* int32 technician_count */ 3:
                    message.technicianCount = reader.int32();
                    break;
                case /* double total_revenue */ 4:
                    message.totalRevenue = reader.double();
                    break;
                case /* double average_revenue_per_technician */ 5:
                    message.averageRevenuePerTechnician = reader.double();
                    break;
                case /* double total_billable_hours */ 6:
                    message.totalBillableHours = reader.double();
                    break;
                case /* double average_utilization */ 7:
                    message.averageUtilization = reader.double();
                    break;
                case /* int32 total_jobs */ 8:
                    message.totalJobs = reader.int32();
                    break;
                case /* double average_jobs_per_technician */ 9:
                    message.averageJobsPerTechnician = reader.double();
                    break;
                case /* int32 total_callbacks */ 10:
                    message.totalCallbacks = reader.int32();
                    break;
                case /* double callback_rate */ 11:
                    message.callbackRate = reader.double();
                    break;
                case /* double gross_profit_margin_percentage */ 12:
                    message.grossProfitMarginPercentage = reader.double();
                    break;
                case /* repeated kalos.analytics.v1.DepartmentJobTypeBreakdown job_type_breakdown */ 13:
                    message.jobTypeBreakdown.push(DepartmentJobTypeBreakdown.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 department_id = 1; */
        if (message.departmentId !== 0)
            writer.tag(1, WireType.Varint).int32(message.departmentId);
        /* string department_name = 2; */
        if (message.departmentName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.departmentName);
        /* int32 technician_count = 3; */
        if (message.technicianCount !== 0)
            writer.tag(3, WireType.Varint).int32(message.technicianCount);
        /* double total_revenue = 4; */
        if (message.totalRevenue !== 0)
            writer.tag(4, WireType.Bit64).double(message.totalRevenue);
        /* double average_revenue_per_technician = 5; */
        if (message.averageRevenuePerTechnician !== 0)
            writer.tag(5, WireType.Bit64).double(message.averageRevenuePerTechnician);
        /* double total_billable_hours = 6; */
        if (message.totalBillableHours !== 0)
            writer.tag(6, WireType.Bit64).double(message.totalBillableHours);
        /* double average_utilization = 7; */
        if (message.averageUtilization !== 0)
            writer.tag(7, WireType.Bit64).double(message.averageUtilization);
        /* int32 total_jobs = 8; */
        if (message.totalJobs !== 0)
            writer.tag(8, WireType.Varint).int32(message.totalJobs);
        /* double average_jobs_per_technician = 9; */
        if (message.averageJobsPerTechnician !== 0)
            writer.tag(9, WireType.Bit64).double(message.averageJobsPerTechnician);
        /* int32 total_callbacks = 10; */
        if (message.totalCallbacks !== 0)
            writer.tag(10, WireType.Varint).int32(message.totalCallbacks);
        /* double callback_rate = 11; */
        if (message.callbackRate !== 0)
            writer.tag(11, WireType.Bit64).double(message.callbackRate);
        /* double gross_profit_margin_percentage = 12; */
        if (message.grossProfitMarginPercentage !== 0)
            writer.tag(12, WireType.Bit64).double(message.grossProfitMarginPercentage);
        /* repeated kalos.analytics.v1.DepartmentJobTypeBreakdown job_type_breakdown = 13; */
        for (let i = 0; i < message.jobTypeBreakdown.length; i++)
            DepartmentJobTypeBreakdown.internalBinaryWrite(message.jobTypeBreakdown[i], writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.TechnicianDepartmentBreakdown
 */
export const TechnicianDepartmentBreakdown = new TechnicianDepartmentBreakdown$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DepartmentJobTypeBreakdown$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.DepartmentJobTypeBreakdown", [
            { no: 1, name: "job_type_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "job_type_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "total_jobs", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "total_revenue", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "gross_profit_margin_percentage", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "technician_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "average_revenue_per_job", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.jobTypeId = 0;
        message.jobTypeName = "";
        message.totalJobs = 0;
        message.totalRevenue = 0;
        message.grossProfitMarginPercentage = 0;
        message.technicianCount = 0;
        message.averageRevenuePerJob = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 job_type_id */ 1:
                    message.jobTypeId = reader.int32();
                    break;
                case /* string job_type_name */ 2:
                    message.jobTypeName = reader.string();
                    break;
                case /* int32 total_jobs */ 3:
                    message.totalJobs = reader.int32();
                    break;
                case /* double total_revenue */ 4:
                    message.totalRevenue = reader.double();
                    break;
                case /* double gross_profit_margin_percentage */ 5:
                    message.grossProfitMarginPercentage = reader.double();
                    break;
                case /* int32 technician_count */ 6:
                    message.technicianCount = reader.int32();
                    break;
                case /* double average_revenue_per_job */ 7:
                    message.averageRevenuePerJob = reader.double();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 job_type_id = 1; */
        if (message.jobTypeId !== 0)
            writer.tag(1, WireType.Varint).int32(message.jobTypeId);
        /* string job_type_name = 2; */
        if (message.jobTypeName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.jobTypeName);
        /* int32 total_jobs = 3; */
        if (message.totalJobs !== 0)
            writer.tag(3, WireType.Varint).int32(message.totalJobs);
        /* double total_revenue = 4; */
        if (message.totalRevenue !== 0)
            writer.tag(4, WireType.Bit64).double(message.totalRevenue);
        /* double gross_profit_margin_percentage = 5; */
        if (message.grossProfitMarginPercentage !== 0)
            writer.tag(5, WireType.Bit64).double(message.grossProfitMarginPercentage);
        /* int32 technician_count = 6; */
        if (message.technicianCount !== 0)
            writer.tag(6, WireType.Varint).int32(message.technicianCount);
        /* double average_revenue_per_job = 7; */
        if (message.averageRevenuePerJob !== 0)
            writer.tag(7, WireType.Bit64).double(message.averageRevenuePerJob);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.DepartmentJobTypeBreakdown
 */
export const DepartmentJobTypeBreakdown = new DepartmentJobTypeBreakdown$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TechnicianPerformanceDetailRequest$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.TechnicianPerformanceDetailRequest", [
            { no: 1, name: "technician_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "filter", kind: "message", T: () => StandardMetricsFilter }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.technicianId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 technician_id */ 1:
                    message.technicianId = reader.int32();
                    break;
                case /* kalos.analytics.v1.StandardMetricsFilter filter */ 2:
                    message.filter = StandardMetricsFilter.internalBinaryRead(reader, reader.uint32(), options, message.filter);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 technician_id = 1; */
        if (message.technicianId !== 0)
            writer.tag(1, WireType.Varint).int32(message.technicianId);
        /* kalos.analytics.v1.StandardMetricsFilter filter = 2; */
        if (message.filter)
            StandardMetricsFilter.internalBinaryWrite(message.filter, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.TechnicianPerformanceDetailRequest
 */
export const TechnicianPerformanceDetailRequest = new TechnicianPerformanceDetailRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TechnicianPerformanceDetailResponse$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.TechnicianPerformanceDetailResponse", [
            { no: 1, name: "technician_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "technician_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "department_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "department_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "total_revenue", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "average_job_value", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 7, name: "total_jobs", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "utilization_percentage", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 9, name: "billable_hours", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 10, name: "non_billable_hours", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 11, name: "overtime_hours", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 12, name: "unplanned_time_off_hours", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 13, name: "travel_expenses", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 14, name: "gross_profit_margin_percentage", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 15, name: "sales_performance", kind: "message", T: () => TechnicianSalesPerformance },
            { no: 16, name: "work_efficiency", kind: "message", T: () => TechnicianWorkEfficiency },
            { no: 17, name: "callback_analysis", kind: "message", T: () => TechnicianCallbackDetail },
            { no: 18, name: "calculated_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.technicianId = 0;
        message.technicianName = "";
        message.departmentId = 0;
        message.departmentName = "";
        message.totalRevenue = 0;
        message.averageJobValue = 0;
        message.totalJobs = 0;
        message.utilizationPercentage = 0;
        message.billableHours = 0;
        message.nonBillableHours = 0;
        message.overtimeHours = 0;
        message.unplannedTimeOffHours = 0;
        message.travelExpenses = 0;
        message.grossProfitMarginPercentage = 0;
        message.calculatedAt = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 technician_id */ 1:
                    message.technicianId = reader.int32();
                    break;
                case /* string technician_name */ 2:
                    message.technicianName = reader.string();
                    break;
                case /* int32 department_id */ 3:
                    message.departmentId = reader.int32();
                    break;
                case /* string department_name */ 4:
                    message.departmentName = reader.string();
                    break;
                case /* double total_revenue */ 5:
                    message.totalRevenue = reader.double();
                    break;
                case /* double average_job_value */ 6:
                    message.averageJobValue = reader.double();
                    break;
                case /* int32 total_jobs */ 7:
                    message.totalJobs = reader.int32();
                    break;
                case /* double utilization_percentage */ 8:
                    message.utilizationPercentage = reader.double();
                    break;
                case /* double billable_hours */ 9:
                    message.billableHours = reader.double();
                    break;
                case /* double non_billable_hours */ 10:
                    message.nonBillableHours = reader.double();
                    break;
                case /* double overtime_hours */ 11:
                    message.overtimeHours = reader.double();
                    break;
                case /* double unplanned_time_off_hours */ 12:
                    message.unplannedTimeOffHours = reader.double();
                    break;
                case /* double travel_expenses */ 13:
                    message.travelExpenses = reader.double();
                    break;
                case /* double gross_profit_margin_percentage */ 14:
                    message.grossProfitMarginPercentage = reader.double();
                    break;
                case /* kalos.analytics.v1.TechnicianSalesPerformance sales_performance */ 15:
                    message.salesPerformance = TechnicianSalesPerformance.internalBinaryRead(reader, reader.uint32(), options, message.salesPerformance);
                    break;
                case /* kalos.analytics.v1.TechnicianWorkEfficiency work_efficiency */ 16:
                    message.workEfficiency = TechnicianWorkEfficiency.internalBinaryRead(reader, reader.uint32(), options, message.workEfficiency);
                    break;
                case /* kalos.analytics.v1.TechnicianCallbackDetail callback_analysis */ 17:
                    message.callbackAnalysis = TechnicianCallbackDetail.internalBinaryRead(reader, reader.uint32(), options, message.callbackAnalysis);
                    break;
                case /* string calculated_at */ 18:
                    message.calculatedAt = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 technician_id = 1; */
        if (message.technicianId !== 0)
            writer.tag(1, WireType.Varint).int32(message.technicianId);
        /* string technician_name = 2; */
        if (message.technicianName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.technicianName);
        /* int32 department_id = 3; */
        if (message.departmentId !== 0)
            writer.tag(3, WireType.Varint).int32(message.departmentId);
        /* string department_name = 4; */
        if (message.departmentName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.departmentName);
        /* double total_revenue = 5; */
        if (message.totalRevenue !== 0)
            writer.tag(5, WireType.Bit64).double(message.totalRevenue);
        /* double average_job_value = 6; */
        if (message.averageJobValue !== 0)
            writer.tag(6, WireType.Bit64).double(message.averageJobValue);
        /* int32 total_jobs = 7; */
        if (message.totalJobs !== 0)
            writer.tag(7, WireType.Varint).int32(message.totalJobs);
        /* double utilization_percentage = 8; */
        if (message.utilizationPercentage !== 0)
            writer.tag(8, WireType.Bit64).double(message.utilizationPercentage);
        /* double billable_hours = 9; */
        if (message.billableHours !== 0)
            writer.tag(9, WireType.Bit64).double(message.billableHours);
        /* double non_billable_hours = 10; */
        if (message.nonBillableHours !== 0)
            writer.tag(10, WireType.Bit64).double(message.nonBillableHours);
        /* double overtime_hours = 11; */
        if (message.overtimeHours !== 0)
            writer.tag(11, WireType.Bit64).double(message.overtimeHours);
        /* double unplanned_time_off_hours = 12; */
        if (message.unplannedTimeOffHours !== 0)
            writer.tag(12, WireType.Bit64).double(message.unplannedTimeOffHours);
        /* double travel_expenses = 13; */
        if (message.travelExpenses !== 0)
            writer.tag(13, WireType.Bit64).double(message.travelExpenses);
        /* double gross_profit_margin_percentage = 14; */
        if (message.grossProfitMarginPercentage !== 0)
            writer.tag(14, WireType.Bit64).double(message.grossProfitMarginPercentage);
        /* kalos.analytics.v1.TechnicianSalesPerformance sales_performance = 15; */
        if (message.salesPerformance)
            TechnicianSalesPerformance.internalBinaryWrite(message.salesPerformance, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* kalos.analytics.v1.TechnicianWorkEfficiency work_efficiency = 16; */
        if (message.workEfficiency)
            TechnicianWorkEfficiency.internalBinaryWrite(message.workEfficiency, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* kalos.analytics.v1.TechnicianCallbackDetail callback_analysis = 17; */
        if (message.callbackAnalysis)
            TechnicianCallbackDetail.internalBinaryWrite(message.callbackAnalysis, writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        /* string calculated_at = 18; */
        if (message.calculatedAt !== "")
            writer.tag(18, WireType.LengthDelimited).string(message.calculatedAt);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.TechnicianPerformanceDetailResponse
 */
export const TechnicianPerformanceDetailResponse = new TechnicianPerformanceDetailResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TechnicianSalesPerformance$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.TechnicianSalesPerformance", [
            { no: 1, name: "sell_sheets_created", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "sell_sheets_signed", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "spiffs_approved", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "conversion_rate", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "spiffs_by_category", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SpiffCategoryBreakdown },
            { no: 5, name: "volume_by_category", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => JobTypeVolumeBreakdown }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.sellSheetsCreated = 0;
        message.sellSheetsSigned = 0;
        message.spiffsApproved = 0;
        message.conversionRate = 0;
        message.spiffsByCategory = [];
        message.volumeByCategory = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 sell_sheets_created */ 1:
                    message.sellSheetsCreated = reader.int32();
                    break;
                case /* int32 sell_sheets_signed */ 6:
                    message.sellSheetsSigned = reader.int32();
                    break;
                case /* int32 spiffs_approved */ 2:
                    message.spiffsApproved = reader.int32();
                    break;
                case /* double conversion_rate */ 3:
                    message.conversionRate = reader.double();
                    break;
                case /* repeated kalos.analytics.v1.SpiffCategoryBreakdown spiffs_by_category */ 4:
                    message.spiffsByCategory.push(SpiffCategoryBreakdown.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated kalos.analytics.v1.JobTypeVolumeBreakdown volume_by_category */ 5:
                    message.volumeByCategory.push(JobTypeVolumeBreakdown.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 sell_sheets_created = 1; */
        if (message.sellSheetsCreated !== 0)
            writer.tag(1, WireType.Varint).int32(message.sellSheetsCreated);
        /* int32 spiffs_approved = 2; */
        if (message.spiffsApproved !== 0)
            writer.tag(2, WireType.Varint).int32(message.spiffsApproved);
        /* double conversion_rate = 3; */
        if (message.conversionRate !== 0)
            writer.tag(3, WireType.Bit64).double(message.conversionRate);
        /* repeated kalos.analytics.v1.SpiffCategoryBreakdown spiffs_by_category = 4; */
        for (let i = 0; i < message.spiffsByCategory.length; i++)
            SpiffCategoryBreakdown.internalBinaryWrite(message.spiffsByCategory[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* repeated kalos.analytics.v1.JobTypeVolumeBreakdown volume_by_category = 5; */
        for (let i = 0; i < message.volumeByCategory.length; i++)
            JobTypeVolumeBreakdown.internalBinaryWrite(message.volumeByCategory[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* int32 sell_sheets_signed = 6; */
        if (message.sellSheetsSigned !== 0)
            writer.tag(6, WireType.Varint).int32(message.sellSheetsSigned);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.TechnicianSalesPerformance
 */
export const TechnicianSalesPerformance = new TechnicianSalesPerformance$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SpiffCategoryBreakdown$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.SpiffCategoryBreakdown", [
            { no: 1, name: "category_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "category_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "spiff_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "total_value", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "percentage_of_total", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.categoryCode = "";
        message.categoryName = "";
        message.spiffCount = 0;
        message.totalValue = 0;
        message.percentageOfTotal = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string category_code */ 1:
                    message.categoryCode = reader.string();
                    break;
                case /* string category_name */ 2:
                    message.categoryName = reader.string();
                    break;
                case /* int32 spiff_count */ 3:
                    message.spiffCount = reader.int32();
                    break;
                case /* double total_value */ 4:
                    message.totalValue = reader.double();
                    break;
                case /* double percentage_of_total */ 5:
                    message.percentageOfTotal = reader.double();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string category_code = 1; */
        if (message.categoryCode !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.categoryCode);
        /* string category_name = 2; */
        if (message.categoryName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.categoryName);
        /* int32 spiff_count = 3; */
        if (message.spiffCount !== 0)
            writer.tag(3, WireType.Varint).int32(message.spiffCount);
        /* double total_value = 4; */
        if (message.totalValue !== 0)
            writer.tag(4, WireType.Bit64).double(message.totalValue);
        /* double percentage_of_total = 5; */
        if (message.percentageOfTotal !== 0)
            writer.tag(5, WireType.Bit64).double(message.percentageOfTotal);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.SpiffCategoryBreakdown
 */
export const SpiffCategoryBreakdown = new SpiffCategoryBreakdown$Type();
// @generated message type with reflection information, may provide speed optimized methods
class JobTypeVolumeBreakdown$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.JobTypeVolumeBreakdown", [
            { no: 1, name: "job_type_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "job_type_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "job_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "percentage_of_total", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.jobTypeId = 0;
        message.jobTypeName = "";
        message.jobCount = 0;
        message.percentageOfTotal = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 job_type_id */ 1:
                    message.jobTypeId = reader.int32();
                    break;
                case /* string job_type_name */ 2:
                    message.jobTypeName = reader.string();
                    break;
                case /* int32 job_count */ 3:
                    message.jobCount = reader.int32();
                    break;
                case /* double percentage_of_total */ 4:
                    message.percentageOfTotal = reader.double();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 job_type_id = 1; */
        if (message.jobTypeId !== 0)
            writer.tag(1, WireType.Varint).int32(message.jobTypeId);
        /* string job_type_name = 2; */
        if (message.jobTypeName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.jobTypeName);
        /* int32 job_count = 3; */
        if (message.jobCount !== 0)
            writer.tag(3, WireType.Varint).int32(message.jobCount);
        /* double percentage_of_total = 4; */
        if (message.percentageOfTotal !== 0)
            writer.tag(4, WireType.Bit64).double(message.percentageOfTotal);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.JobTypeVolumeBreakdown
 */
export const JobTypeVolumeBreakdown = new JobTypeVolumeBreakdown$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TechnicianWorkEfficiency$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.TechnicianWorkEfficiency", [
            { no: 1, name: "job_type_breakdown", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => JobTypeEfficiencyMetrics }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.jobTypeBreakdown = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated kalos.analytics.v1.JobTypeEfficiencyMetrics job_type_breakdown */ 1:
                    message.jobTypeBreakdown.push(JobTypeEfficiencyMetrics.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated kalos.analytics.v1.JobTypeEfficiencyMetrics job_type_breakdown = 1; */
        for (let i = 0; i < message.jobTypeBreakdown.length; i++)
            JobTypeEfficiencyMetrics.internalBinaryWrite(message.jobTypeBreakdown[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.TechnicianWorkEfficiency
 */
export const TechnicianWorkEfficiency = new TechnicianWorkEfficiency$Type();
// @generated message type with reflection information, may provide speed optimized methods
class JobTypeEfficiencyMetrics$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.JobTypeEfficiencyMetrics", [
            { no: 1, name: "job_type_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "job_type_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "total_jobs", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "average_time_on_site_hours", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "total_revenue", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "revenue_per_hour", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 7, name: "gross_profit_margin_percentage", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.jobTypeId = 0;
        message.jobTypeName = "";
        message.totalJobs = 0;
        message.averageTimeOnSiteHours = 0;
        message.totalRevenue = 0;
        message.revenuePerHour = 0;
        message.grossProfitMarginPercentage = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 job_type_id */ 1:
                    message.jobTypeId = reader.int32();
                    break;
                case /* string job_type_name */ 2:
                    message.jobTypeName = reader.string();
                    break;
                case /* int32 total_jobs */ 3:
                    message.totalJobs = reader.int32();
                    break;
                case /* double average_time_on_site_hours */ 4:
                    message.averageTimeOnSiteHours = reader.double();
                    break;
                case /* double total_revenue */ 5:
                    message.totalRevenue = reader.double();
                    break;
                case /* double revenue_per_hour */ 6:
                    message.revenuePerHour = reader.double();
                    break;
                case /* double gross_profit_margin_percentage */ 7:
                    message.grossProfitMarginPercentage = reader.double();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 job_type_id = 1; */
        if (message.jobTypeId !== 0)
            writer.tag(1, WireType.Varint).int32(message.jobTypeId);
        /* string job_type_name = 2; */
        if (message.jobTypeName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.jobTypeName);
        /* int32 total_jobs = 3; */
        if (message.totalJobs !== 0)
            writer.tag(3, WireType.Varint).int32(message.totalJobs);
        /* double average_time_on_site_hours = 4; */
        if (message.averageTimeOnSiteHours !== 0)
            writer.tag(4, WireType.Bit64).double(message.averageTimeOnSiteHours);
        /* double total_revenue = 5; */
        if (message.totalRevenue !== 0)
            writer.tag(5, WireType.Bit64).double(message.totalRevenue);
        /* double revenue_per_hour = 6; */
        if (message.revenuePerHour !== 0)
            writer.tag(6, WireType.Bit64).double(message.revenuePerHour);
        /* double gross_profit_margin_percentage = 7; */
        if (message.grossProfitMarginPercentage !== 0)
            writer.tag(7, WireType.Bit64).double(message.grossProfitMarginPercentage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.JobTypeEfficiencyMetrics
 */
export const JobTypeEfficiencyMetrics = new JobTypeEfficiencyMetrics$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TechnicianCallbackDetail$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.TechnicianCallbackDetail", [
            { no: 1, name: "total_callbacks", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "callback_rate", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "callbacks_by_type", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CallbackTypeBreakdown },
            { no: 4, name: "callback_list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CallbackItem }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.totalCallbacks = 0;
        message.callbackRate = 0;
        message.callbacksByType = [];
        message.callbackList = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 total_callbacks */ 1:
                    message.totalCallbacks = reader.int32();
                    break;
                case /* double callback_rate */ 2:
                    message.callbackRate = reader.double();
                    break;
                case /* repeated kalos.analytics.v1.CallbackTypeBreakdown callbacks_by_type */ 3:
                    message.callbacksByType.push(CallbackTypeBreakdown.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated kalos.analytics.v1.CallbackItem callback_list */ 4:
                    message.callbackList.push(CallbackItem.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 total_callbacks = 1; */
        if (message.totalCallbacks !== 0)
            writer.tag(1, WireType.Varint).int32(message.totalCallbacks);
        /* double callback_rate = 2; */
        if (message.callbackRate !== 0)
            writer.tag(2, WireType.Bit64).double(message.callbackRate);
        /* repeated kalos.analytics.v1.CallbackTypeBreakdown callbacks_by_type = 3; */
        for (let i = 0; i < message.callbacksByType.length; i++)
            CallbackTypeBreakdown.internalBinaryWrite(message.callbacksByType[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated kalos.analytics.v1.CallbackItem callback_list = 4; */
        for (let i = 0; i < message.callbackList.length; i++)
            CallbackItem.internalBinaryWrite(message.callbackList[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.TechnicianCallbackDetail
 */
export const TechnicianCallbackDetail = new TechnicianCallbackDetail$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CallbackTypeBreakdown$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.CallbackTypeBreakdown", [
            { no: 1, name: "reason_category", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "callback_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "percentage_of_total", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "percentage_of_all_jobs", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.reasonCategory = "";
        message.callbackCount = 0;
        message.percentageOfTotal = 0;
        message.percentageOfAllJobs = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string reason_category */ 1:
                    message.reasonCategory = reader.string();
                    break;
                case /* int32 callback_count */ 2:
                    message.callbackCount = reader.int32();
                    break;
                case /* double percentage_of_total */ 3:
                    message.percentageOfTotal = reader.double();
                    break;
                case /* double percentage_of_all_jobs */ 4:
                    message.percentageOfAllJobs = reader.double();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string reason_category = 1; */
        if (message.reasonCategory !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.reasonCategory);
        /* int32 callback_count = 2; */
        if (message.callbackCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.callbackCount);
        /* double percentage_of_total = 3; */
        if (message.percentageOfTotal !== 0)
            writer.tag(3, WireType.Bit64).double(message.percentageOfTotal);
        /* double percentage_of_all_jobs = 4; */
        if (message.percentageOfAllJobs !== 0)
            writer.tag(4, WireType.Bit64).double(message.percentageOfAllJobs);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.CallbackTypeBreakdown
 */
export const CallbackTypeBreakdown = new CallbackTypeBreakdown$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CallbackItem$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.CallbackItem", [
            { no: 1, name: "event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "job_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "customer_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "service_address", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "completion_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "callback_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "reason_category", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "reason_description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "job_type_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "job_type_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "cost", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.eventId = 0;
        message.jobNumber = "";
        message.customerName = "";
        message.serviceAddress = "";
        message.completionDate = "";
        message.callbackDate = "";
        message.reasonCategory = "";
        message.reasonDescription = "";
        message.jobTypeId = 0;
        message.jobTypeName = "";
        message.cost = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 event_id */ 1:
                    message.eventId = reader.int32();
                    break;
                case /* string job_number */ 2:
                    message.jobNumber = reader.string();
                    break;
                case /* string customer_name */ 3:
                    message.customerName = reader.string();
                    break;
                case /* string service_address */ 4:
                    message.serviceAddress = reader.string();
                    break;
                case /* string completion_date */ 5:
                    message.completionDate = reader.string();
                    break;
                case /* string callback_date */ 6:
                    message.callbackDate = reader.string();
                    break;
                case /* string reason_category */ 7:
                    message.reasonCategory = reader.string();
                    break;
                case /* string reason_description */ 8:
                    message.reasonDescription = reader.string();
                    break;
                case /* int32 job_type_id */ 9:
                    message.jobTypeId = reader.int32();
                    break;
                case /* string job_type_name */ 10:
                    message.jobTypeName = reader.string();
                    break;
                case /* double cost */ 11:
                    message.cost = reader.double();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 event_id = 1; */
        if (message.eventId !== 0)
            writer.tag(1, WireType.Varint).int32(message.eventId);
        /* string job_number = 2; */
        if (message.jobNumber !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.jobNumber);
        /* string customer_name = 3; */
        if (message.customerName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.customerName);
        /* string service_address = 4; */
        if (message.serviceAddress !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.serviceAddress);
        /* string completion_date = 5; */
        if (message.completionDate !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.completionDate);
        /* string callback_date = 6; */
        if (message.callbackDate !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.callbackDate);
        /* string reason_category = 7; */
        if (message.reasonCategory !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.reasonCategory);
        /* string reason_description = 8; */
        if (message.reasonDescription !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.reasonDescription);
        /* int32 job_type_id = 9; */
        if (message.jobTypeId !== 0)
            writer.tag(9, WireType.Varint).int32(message.jobTypeId);
        /* string job_type_name = 10; */
        if (message.jobTypeName !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.jobTypeName);
        /* double cost = 11; */
        if (message.cost !== 0)
            writer.tag(11, WireType.Bit64).double(message.cost);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.CallbackItem
 */
export const CallbackItem = new CallbackItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ServiceQualityMetricsRequest$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.ServiceQualityMetricsRequest", [
            { no: 1, name: "filter", kind: "message", T: () => StandardMetricsFilter },
            { no: 2, name: "include_time_series", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "time_granularity", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.includeTimeSeries = false;
        message.timeGranularity = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* kalos.analytics.v1.StandardMetricsFilter filter */ 1:
                    message.filter = StandardMetricsFilter.internalBinaryRead(reader, reader.uint32(), options, message.filter);
                    break;
                case /* bool include_time_series */ 2:
                    message.includeTimeSeries = reader.bool();
                    break;
                case /* string time_granularity */ 3:
                    message.timeGranularity = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* kalos.analytics.v1.StandardMetricsFilter filter = 1; */
        if (message.filter)
            StandardMetricsFilter.internalBinaryWrite(message.filter, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool include_time_series = 2; */
        if (message.includeTimeSeries !== false)
            writer.tag(2, WireType.Varint).bool(message.includeTimeSeries);
        /* string time_granularity = 3; */
        if (message.timeGranularity !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.timeGranularity);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.ServiceQualityMetricsRequest
 */
export const ServiceQualityMetricsRequest = new ServiceQualityMetricsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ServiceQualityMetricsResponse$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.ServiceQualityMetricsResponse", [
            { no: 1, name: "first_time_fix_rate", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "callback_rate", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "on_time_arrival_rate", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "total_callbacks", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "callback_breakdown", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CallbackReasonBreakdown },
            { no: 6, name: "departments", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ServiceQualityDepartmentBreakdown },
            { no: 7, name: "technician_callbacks", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TechnicianCallbackMetrics },
            { no: 8, name: "time_series", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TimeSeriesData },
            { no: 9, name: "calculated_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "total_jobs", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.firstTimeFixRate = 0;
        message.callbackRate = 0;
        message.onTimeArrivalRate = 0;
        message.totalCallbacks = 0;
        message.callbackBreakdown = [];
        message.departments = [];
        message.technicianCallbacks = [];
        message.timeSeries = [];
        message.calculatedAt = "";
        message.totalJobs = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* double first_time_fix_rate */ 1:
                    message.firstTimeFixRate = reader.double();
                    break;
                case /* double callback_rate */ 2:
                    message.callbackRate = reader.double();
                    break;
                case /* double on_time_arrival_rate */ 3:
                    message.onTimeArrivalRate = reader.double();
                    break;
                case /* int32 total_callbacks */ 4:
                    message.totalCallbacks = reader.int32();
                    break;
                case /* repeated kalos.analytics.v1.CallbackReasonBreakdown callback_breakdown */ 5:
                    message.callbackBreakdown.push(CallbackReasonBreakdown.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated kalos.analytics.v1.ServiceQualityDepartmentBreakdown departments */ 6:
                    message.departments.push(ServiceQualityDepartmentBreakdown.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated kalos.analytics.v1.TechnicianCallbackMetrics technician_callbacks */ 7:
                    message.technicianCallbacks.push(TechnicianCallbackMetrics.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated kalos.analytics.v1.TimeSeriesData time_series */ 8:
                    message.timeSeries.push(TimeSeriesData.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string calculated_at */ 9:
                    message.calculatedAt = reader.string();
                    break;
                case /* int32 total_jobs */ 10:
                    message.totalJobs = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* double first_time_fix_rate = 1; */
        if (message.firstTimeFixRate !== 0)
            writer.tag(1, WireType.Bit64).double(message.firstTimeFixRate);
        /* double callback_rate = 2; */
        if (message.callbackRate !== 0)
            writer.tag(2, WireType.Bit64).double(message.callbackRate);
        /* double on_time_arrival_rate = 3; */
        if (message.onTimeArrivalRate !== 0)
            writer.tag(3, WireType.Bit64).double(message.onTimeArrivalRate);
        /* int32 total_callbacks = 4; */
        if (message.totalCallbacks !== 0)
            writer.tag(4, WireType.Varint).int32(message.totalCallbacks);
        /* repeated kalos.analytics.v1.CallbackReasonBreakdown callback_breakdown = 5; */
        for (let i = 0; i < message.callbackBreakdown.length; i++)
            CallbackReasonBreakdown.internalBinaryWrite(message.callbackBreakdown[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated kalos.analytics.v1.ServiceQualityDepartmentBreakdown departments = 6; */
        for (let i = 0; i < message.departments.length; i++)
            ServiceQualityDepartmentBreakdown.internalBinaryWrite(message.departments[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* repeated kalos.analytics.v1.TechnicianCallbackMetrics technician_callbacks = 7; */
        for (let i = 0; i < message.technicianCallbacks.length; i++)
            TechnicianCallbackMetrics.internalBinaryWrite(message.technicianCallbacks[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* repeated kalos.analytics.v1.TimeSeriesData time_series = 8; */
        for (let i = 0; i < message.timeSeries.length; i++)
            TimeSeriesData.internalBinaryWrite(message.timeSeries[i], writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* string calculated_at = 9; */
        if (message.calculatedAt !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.calculatedAt);
        /* int32 total_jobs = 10; */
        if (message.totalJobs !== 0)
            writer.tag(10, WireType.Varint).int32(message.totalJobs);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.ServiceQualityMetricsResponse
 */
export const ServiceQualityMetricsResponse = new ServiceQualityMetricsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CallbackReasonBreakdown$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.CallbackReasonBreakdown", [
            { no: 1, name: "reason_category", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "callback_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "percentage_of_total", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "percentage_of_all_jobs", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.reasonCategory = "";
        message.callbackCount = 0;
        message.percentageOfTotal = 0;
        message.percentageOfAllJobs = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string reason_category */ 1:
                    message.reasonCategory = reader.string();
                    break;
                case /* int32 callback_count */ 2:
                    message.callbackCount = reader.int32();
                    break;
                case /* double percentage_of_total */ 3:
                    message.percentageOfTotal = reader.double();
                    break;
                case /* double percentage_of_all_jobs */ 4:
                    message.percentageOfAllJobs = reader.double();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string reason_category = 1; */
        if (message.reasonCategory !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.reasonCategory);
        /* int32 callback_count = 2; */
        if (message.callbackCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.callbackCount);
        /* double percentage_of_total = 3; */
        if (message.percentageOfTotal !== 0)
            writer.tag(3, WireType.Bit64).double(message.percentageOfTotal);
        /* double percentage_of_all_jobs = 4; */
        if (message.percentageOfAllJobs !== 0)
            writer.tag(4, WireType.Bit64).double(message.percentageOfAllJobs);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.CallbackReasonBreakdown
 */
export const CallbackReasonBreakdown = new CallbackReasonBreakdown$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ServiceQualityDepartmentBreakdown$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.ServiceQualityDepartmentBreakdown", [
            { no: 1, name: "department_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "department_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "first_time_fix_rate", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "callback_rate", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "on_time_arrival_rate", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "total_jobs", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "total_callbacks", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "callback_breakdown", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CallbackReasonBreakdown },
            { no: 9, name: "job_types", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ServiceQualityJobTypeBreakdown },
            { no: 10, name: "trades", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ServiceQualityTradeBreakdown }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.departmentId = 0;
        message.departmentName = "";
        message.firstTimeFixRate = 0;
        message.callbackRate = 0;
        message.onTimeArrivalRate = 0;
        message.totalJobs = 0;
        message.totalCallbacks = 0;
        message.callbackBreakdown = [];
        message.jobTypes = [];
        message.trades = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 department_id */ 1:
                    message.departmentId = reader.int32();
                    break;
                case /* string department_name */ 2:
                    message.departmentName = reader.string();
                    break;
                case /* double first_time_fix_rate */ 3:
                    message.firstTimeFixRate = reader.double();
                    break;
                case /* double callback_rate */ 4:
                    message.callbackRate = reader.double();
                    break;
                case /* double on_time_arrival_rate */ 5:
                    message.onTimeArrivalRate = reader.double();
                    break;
                case /* int32 total_jobs */ 6:
                    message.totalJobs = reader.int32();
                    break;
                case /* int32 total_callbacks */ 7:
                    message.totalCallbacks = reader.int32();
                    break;
                case /* repeated kalos.analytics.v1.CallbackReasonBreakdown callback_breakdown */ 8:
                    message.callbackBreakdown.push(CallbackReasonBreakdown.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated kalos.analytics.v1.ServiceQualityJobTypeBreakdown job_types */ 9:
                    message.jobTypes.push(ServiceQualityJobTypeBreakdown.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated kalos.analytics.v1.ServiceQualityTradeBreakdown trades */ 10:
                    message.trades.push(ServiceQualityTradeBreakdown.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 department_id = 1; */
        if (message.departmentId !== 0)
            writer.tag(1, WireType.Varint).int32(message.departmentId);
        /* string department_name = 2; */
        if (message.departmentName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.departmentName);
        /* double first_time_fix_rate = 3; */
        if (message.firstTimeFixRate !== 0)
            writer.tag(3, WireType.Bit64).double(message.firstTimeFixRate);
        /* double callback_rate = 4; */
        if (message.callbackRate !== 0)
            writer.tag(4, WireType.Bit64).double(message.callbackRate);
        /* double on_time_arrival_rate = 5; */
        if (message.onTimeArrivalRate !== 0)
            writer.tag(5, WireType.Bit64).double(message.onTimeArrivalRate);
        /* int32 total_jobs = 6; */
        if (message.totalJobs !== 0)
            writer.tag(6, WireType.Varint).int32(message.totalJobs);
        /* int32 total_callbacks = 7; */
        if (message.totalCallbacks !== 0)
            writer.tag(7, WireType.Varint).int32(message.totalCallbacks);
        /* repeated kalos.analytics.v1.CallbackReasonBreakdown callback_breakdown = 8; */
        for (let i = 0; i < message.callbackBreakdown.length; i++)
            CallbackReasonBreakdown.internalBinaryWrite(message.callbackBreakdown[i], writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* repeated kalos.analytics.v1.ServiceQualityJobTypeBreakdown job_types = 9; */
        for (let i = 0; i < message.jobTypes.length; i++)
            ServiceQualityJobTypeBreakdown.internalBinaryWrite(message.jobTypes[i], writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* repeated kalos.analytics.v1.ServiceQualityTradeBreakdown trades = 10; */
        for (let i = 0; i < message.trades.length; i++)
            ServiceQualityTradeBreakdown.internalBinaryWrite(message.trades[i], writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.ServiceQualityDepartmentBreakdown
 */
export const ServiceQualityDepartmentBreakdown = new ServiceQualityDepartmentBreakdown$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ServiceQualityTradeBreakdown$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.ServiceQualityTradeBreakdown", [
            { no: 1, name: "event_trade_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "trade_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "callback_rate", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "on_time_arrival_rate", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "total_jobs", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "total_callbacks", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "job_types", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ServiceQualityJobTypeBreakdown }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.eventTradeId = 0;
        message.tradeName = "";
        message.callbackRate = 0;
        message.onTimeArrivalRate = 0;
        message.totalJobs = 0;
        message.totalCallbacks = 0;
        message.jobTypes = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 event_trade_id */ 1:
                    message.eventTradeId = reader.int32();
                    break;
                case /* string trade_name */ 2:
                    message.tradeName = reader.string();
                    break;
                case /* double callback_rate */ 4:
                    message.callbackRate = reader.double();
                    break;
                case /* double on_time_arrival_rate */ 5:
                    message.onTimeArrivalRate = reader.double();
                    break;
                case /* int32 total_jobs */ 6:
                    message.totalJobs = reader.int32();
                    break;
                case /* int32 total_callbacks */ 7:
                    message.totalCallbacks = reader.int32();
                    break;
                case /* repeated kalos.analytics.v1.ServiceQualityJobTypeBreakdown job_types */ 9:
                    message.jobTypes.push(ServiceQualityJobTypeBreakdown.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 event_trade_id = 1; */
        if (message.eventTradeId !== 0)
            writer.tag(1, WireType.Varint).int32(message.eventTradeId);
        /* string trade_name = 2; */
        if (message.tradeName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.tradeName);
        /* double callback_rate = 4; */
        if (message.callbackRate !== 0)
            writer.tag(4, WireType.Bit64).double(message.callbackRate);
        /* double on_time_arrival_rate = 5; */
        if (message.onTimeArrivalRate !== 0)
            writer.tag(5, WireType.Bit64).double(message.onTimeArrivalRate);
        /* int32 total_jobs = 6; */
        if (message.totalJobs !== 0)
            writer.tag(6, WireType.Varint).int32(message.totalJobs);
        /* int32 total_callbacks = 7; */
        if (message.totalCallbacks !== 0)
            writer.tag(7, WireType.Varint).int32(message.totalCallbacks);
        /* repeated kalos.analytics.v1.ServiceQualityJobTypeBreakdown job_types = 9; */
        for (let i = 0; i < message.jobTypes.length; i++)
            ServiceQualityJobTypeBreakdown.internalBinaryWrite(message.jobTypes[i], writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.ServiceQualityTradeBreakdown
 */
export const ServiceQualityTradeBreakdown = new ServiceQualityTradeBreakdown$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ServiceQualityJobTypeBreakdown$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.ServiceQualityJobTypeBreakdown", [
            { no: 1, name: "job_type_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "job_type_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "first_time_fix_rate", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "callback_rate", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "on_time_arrival_rate", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "total_jobs", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "total_callbacks", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "callback_breakdown", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CallbackReasonBreakdown }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.jobTypeId = 0;
        message.jobTypeName = "";
        message.firstTimeFixRate = 0;
        message.callbackRate = 0;
        message.onTimeArrivalRate = 0;
        message.totalJobs = 0;
        message.totalCallbacks = 0;
        message.callbackBreakdown = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 job_type_id */ 1:
                    message.jobTypeId = reader.int32();
                    break;
                case /* string job_type_name */ 2:
                    message.jobTypeName = reader.string();
                    break;
                case /* double first_time_fix_rate */ 3:
                    message.firstTimeFixRate = reader.double();
                    break;
                case /* double callback_rate */ 4:
                    message.callbackRate = reader.double();
                    break;
                case /* double on_time_arrival_rate */ 5:
                    message.onTimeArrivalRate = reader.double();
                    break;
                case /* int32 total_jobs */ 6:
                    message.totalJobs = reader.int32();
                    break;
                case /* int32 total_callbacks */ 7:
                    message.totalCallbacks = reader.int32();
                    break;
                case /* repeated kalos.analytics.v1.CallbackReasonBreakdown callback_breakdown */ 8:
                    message.callbackBreakdown.push(CallbackReasonBreakdown.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 job_type_id = 1; */
        if (message.jobTypeId !== 0)
            writer.tag(1, WireType.Varint).int32(message.jobTypeId);
        /* string job_type_name = 2; */
        if (message.jobTypeName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.jobTypeName);
        /* double first_time_fix_rate = 3; */
        if (message.firstTimeFixRate !== 0)
            writer.tag(3, WireType.Bit64).double(message.firstTimeFixRate);
        /* double callback_rate = 4; */
        if (message.callbackRate !== 0)
            writer.tag(4, WireType.Bit64).double(message.callbackRate);
        /* double on_time_arrival_rate = 5; */
        if (message.onTimeArrivalRate !== 0)
            writer.tag(5, WireType.Bit64).double(message.onTimeArrivalRate);
        /* int32 total_jobs = 6; */
        if (message.totalJobs !== 0)
            writer.tag(6, WireType.Varint).int32(message.totalJobs);
        /* int32 total_callbacks = 7; */
        if (message.totalCallbacks !== 0)
            writer.tag(7, WireType.Varint).int32(message.totalCallbacks);
        /* repeated kalos.analytics.v1.CallbackReasonBreakdown callback_breakdown = 8; */
        for (let i = 0; i < message.callbackBreakdown.length; i++)
            CallbackReasonBreakdown.internalBinaryWrite(message.callbackBreakdown[i], writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.ServiceQualityJobTypeBreakdown
 */
export const ServiceQualityJobTypeBreakdown = new ServiceQualityJobTypeBreakdown$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TechnicianCallbackMetrics$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.TechnicianCallbackMetrics", [
            { no: 1, name: "technician_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "technician_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "department_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "total_jobs", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "total_callbacks", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "callback_rate", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 7, name: "at_fault_callbacks", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "unreasonable_callbacks", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "miscommunication_callbacks", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "not_at_fault_callbacks", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "callback_breakdown", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TechnicianCallbackBreakdown }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.technicianId = 0;
        message.technicianName = "";
        message.departmentName = "";
        message.totalJobs = 0;
        message.totalCallbacks = 0;
        message.callbackRate = 0;
        message.atFaultCallbacks = 0;
        message.unreasonableCallbacks = 0;
        message.miscommunicationCallbacks = 0;
        message.notAtFaultCallbacks = 0;
        message.callbackBreakdown = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 technician_id */ 1:
                    message.technicianId = reader.int32();
                    break;
                case /* string technician_name */ 2:
                    message.technicianName = reader.string();
                    break;
                case /* string department_name */ 3:
                    message.departmentName = reader.string();
                    break;
                case /* int32 total_jobs */ 4:
                    message.totalJobs = reader.int32();
                    break;
                case /* int32 total_callbacks */ 5:
                    message.totalCallbacks = reader.int32();
                    break;
                case /* double callback_rate */ 6:
                    message.callbackRate = reader.double();
                    break;
                case /* int32 at_fault_callbacks */ 7:
                    message.atFaultCallbacks = reader.int32();
                    break;
                case /* int32 unreasonable_callbacks */ 8:
                    message.unreasonableCallbacks = reader.int32();
                    break;
                case /* int32 miscommunication_callbacks */ 9:
                    message.miscommunicationCallbacks = reader.int32();
                    break;
                case /* int32 not_at_fault_callbacks */ 10:
                    message.notAtFaultCallbacks = reader.int32();
                    break;
                case /* repeated kalos.analytics.v1.TechnicianCallbackBreakdown callback_breakdown */ 11:
                    message.callbackBreakdown.push(TechnicianCallbackBreakdown.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 technician_id = 1; */
        if (message.technicianId !== 0)
            writer.tag(1, WireType.Varint).int32(message.technicianId);
        /* string technician_name = 2; */
        if (message.technicianName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.technicianName);
        /* string department_name = 3; */
        if (message.departmentName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.departmentName);
        /* int32 total_jobs = 4; */
        if (message.totalJobs !== 0)
            writer.tag(4, WireType.Varint).int32(message.totalJobs);
        /* int32 total_callbacks = 5; */
        if (message.totalCallbacks !== 0)
            writer.tag(5, WireType.Varint).int32(message.totalCallbacks);
        /* double callback_rate = 6; */
        if (message.callbackRate !== 0)
            writer.tag(6, WireType.Bit64).double(message.callbackRate);
        /* int32 at_fault_callbacks = 7; */
        if (message.atFaultCallbacks !== 0)
            writer.tag(7, WireType.Varint).int32(message.atFaultCallbacks);
        /* int32 unreasonable_callbacks = 8; */
        if (message.unreasonableCallbacks !== 0)
            writer.tag(8, WireType.Varint).int32(message.unreasonableCallbacks);
        /* int32 miscommunication_callbacks = 9; */
        if (message.miscommunicationCallbacks !== 0)
            writer.tag(9, WireType.Varint).int32(message.miscommunicationCallbacks);
        /* int32 not_at_fault_callbacks = 10; */
        if (message.notAtFaultCallbacks !== 0)
            writer.tag(10, WireType.Varint).int32(message.notAtFaultCallbacks);
        /* repeated kalos.analytics.v1.TechnicianCallbackBreakdown callback_breakdown = 11; */
        for (let i = 0; i < message.callbackBreakdown.length; i++)
            TechnicianCallbackBreakdown.internalBinaryWrite(message.callbackBreakdown[i], writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.TechnicianCallbackMetrics
 */
export const TechnicianCallbackMetrics = new TechnicianCallbackMetrics$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TechnicianCallbackBreakdown$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.TechnicianCallbackBreakdown", [
            { no: 1, name: "disposition_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "disposition_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "callback_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "percentage_of_total", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.dispositionId = 0;
        message.dispositionName = "";
        message.callbackCount = 0;
        message.percentageOfTotal = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 disposition_id */ 1:
                    message.dispositionId = reader.int32();
                    break;
                case /* string disposition_name */ 2:
                    message.dispositionName = reader.string();
                    break;
                case /* int32 callback_count */ 3:
                    message.callbackCount = reader.int32();
                    break;
                case /* double percentage_of_total */ 4:
                    message.percentageOfTotal = reader.double();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 disposition_id = 1; */
        if (message.dispositionId !== 0)
            writer.tag(1, WireType.Varint).int32(message.dispositionId);
        /* string disposition_name = 2; */
        if (message.dispositionName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.dispositionName);
        /* int32 callback_count = 3; */
        if (message.callbackCount !== 0)
            writer.tag(3, WireType.Varint).int32(message.callbackCount);
        /* double percentage_of_total = 4; */
        if (message.percentageOfTotal !== 0)
            writer.tag(4, WireType.Bit64).double(message.percentageOfTotal);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.TechnicianCallbackBreakdown
 */
export const TechnicianCallbackBreakdown = new TechnicianCallbackBreakdown$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TechnicianCallbackAnalysisRequest$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.TechnicianCallbackAnalysisRequest", [
            { no: 1, name: "filter", kind: "message", T: () => StandardMetricsFilter },
            { no: 2, name: "search_query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "pagination", kind: "message", T: () => PaginationRequest }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.searchQuery = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* kalos.analytics.v1.StandardMetricsFilter filter */ 1:
                    message.filter = StandardMetricsFilter.internalBinaryRead(reader, reader.uint32(), options, message.filter);
                    break;
                case /* string search_query */ 2:
                    message.searchQuery = reader.string();
                    break;
                case /* kalos.analytics.v1.PaginationRequest pagination */ 3:
                    message.pagination = PaginationRequest.internalBinaryRead(reader, reader.uint32(), options, message.pagination);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* kalos.analytics.v1.StandardMetricsFilter filter = 1; */
        if (message.filter)
            StandardMetricsFilter.internalBinaryWrite(message.filter, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string search_query = 2; */
        if (message.searchQuery !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.searchQuery);
        /* kalos.analytics.v1.PaginationRequest pagination = 3; */
        if (message.pagination)
            PaginationRequest.internalBinaryWrite(message.pagination, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.TechnicianCallbackAnalysisRequest
 */
export const TechnicianCallbackAnalysisRequest = new TechnicianCallbackAnalysisRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TechnicianCallbackAnalysisResponse$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.TechnicianCallbackAnalysisResponse", [
            { no: 1, name: "technicians", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TechnicianCallbackMetrics },
            { no: 2, name: "pagination", kind: "message", T: () => PaginationResponse }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.technicians = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated kalos.analytics.v1.TechnicianCallbackMetrics technicians */ 1:
                    message.technicians.push(TechnicianCallbackMetrics.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* kalos.analytics.v1.PaginationResponse pagination */ 2:
                    message.pagination = PaginationResponse.internalBinaryRead(reader, reader.uint32(), options, message.pagination);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated kalos.analytics.v1.TechnicianCallbackMetrics technicians = 1; */
        for (let i = 0; i < message.technicians.length; i++)
            TechnicianCallbackMetrics.internalBinaryWrite(message.technicians[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* kalos.analytics.v1.PaginationResponse pagination = 2; */
        if (message.pagination)
            PaginationResponse.internalBinaryWrite(message.pagination, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.TechnicianCallbackAnalysisResponse
 */
export const TechnicianCallbackAnalysisResponse = new TechnicianCallbackAnalysisResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FinancialPerformanceMetricsRequest$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.FinancialPerformanceMetricsRequest", [
            { no: 1, name: "filter", kind: "message", T: () => StandardMetricsFilter },
            { no: 2, name: "include_time_series", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "time_granularity", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.includeTimeSeries = false;
        message.timeGranularity = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* kalos.analytics.v1.StandardMetricsFilter filter */ 1:
                    message.filter = StandardMetricsFilter.internalBinaryRead(reader, reader.uint32(), options, message.filter);
                    break;
                case /* bool include_time_series */ 2:
                    message.includeTimeSeries = reader.bool();
                    break;
                case /* string time_granularity */ 3:
                    message.timeGranularity = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* kalos.analytics.v1.StandardMetricsFilter filter = 1; */
        if (message.filter)
            StandardMetricsFilter.internalBinaryWrite(message.filter, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool include_time_series = 2; */
        if (message.includeTimeSeries !== false)
            writer.tag(2, WireType.Varint).bool(message.includeTimeSeries);
        /* string time_granularity = 3; */
        if (message.timeGranularity !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.timeGranularity);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.FinancialPerformanceMetricsRequest
 */
export const FinancialPerformanceMetricsRequest = new FinancialPerformanceMetricsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FinancialPerformanceMetricsResponse$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.FinancialPerformanceMetricsResponse", [
            { no: 1, name: "total_revenue", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "gross_profit", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "net_profit", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "billable_hours_percentage", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "revenue_per_labor_dollar", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "net_profit_per_hour", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 7, name: "break_even_hourly_cost", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 8, name: "average_job_value", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 9, name: "gross_margin_percentage", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 10, name: "net_margin_percentage", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 11, name: "departments", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => FinancialDepartmentBreakdown },
            { no: 12, name: "accounts_receivable", kind: "message", T: () => AccountsReceivableAging },
            { no: 13, name: "time_series", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TimeSeriesData },
            { no: 14, name: "calculated_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "properties", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => FinancialPropertyBreakdown },
            { no: 16, name: "financial_periods", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => FinancialTimePeriod }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.totalRevenue = 0;
        message.grossProfit = 0;
        message.netProfit = 0;
        message.billableHoursPercentage = 0;
        message.revenuePerLaborDollar = 0;
        message.netProfitPerHour = 0;
        message.breakEvenHourlyCost = 0;
        message.averageJobValue = 0;
        message.grossMarginPercentage = 0;
        message.netMarginPercentage = 0;
        message.departments = [];
        message.timeSeries = [];
        message.calculatedAt = "";
        message.properties = [];
        message.financialPeriods = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* double total_revenue */ 1:
                    message.totalRevenue = reader.double();
                    break;
                case /* double gross_profit */ 2:
                    message.grossProfit = reader.double();
                    break;
                case /* double net_profit */ 3:
                    message.netProfit = reader.double();
                    break;
                case /* double billable_hours_percentage */ 4:
                    message.billableHoursPercentage = reader.double();
                    break;
                case /* double revenue_per_labor_dollar */ 5:
                    message.revenuePerLaborDollar = reader.double();
                    break;
                case /* double net_profit_per_hour */ 6:
                    message.netProfitPerHour = reader.double();
                    break;
                case /* double break_even_hourly_cost */ 7:
                    message.breakEvenHourlyCost = reader.double();
                    break;
                case /* double average_job_value */ 8:
                    message.averageJobValue = reader.double();
                    break;
                case /* double gross_margin_percentage */ 9:
                    message.grossMarginPercentage = reader.double();
                    break;
                case /* double net_margin_percentage */ 10:
                    message.netMarginPercentage = reader.double();
                    break;
                case /* repeated kalos.analytics.v1.FinancialDepartmentBreakdown departments */ 11:
                    message.departments.push(FinancialDepartmentBreakdown.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* kalos.analytics.v1.AccountsReceivableAging accounts_receivable */ 12:
                    message.accountsReceivable = AccountsReceivableAging.internalBinaryRead(reader, reader.uint32(), options, message.accountsReceivable);
                    break;
                case /* repeated kalos.analytics.v1.TimeSeriesData time_series */ 13:
                    message.timeSeries.push(TimeSeriesData.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string calculated_at */ 14:
                    message.calculatedAt = reader.string();
                    break;
                case /* repeated kalos.analytics.v1.FinancialPropertyBreakdown properties */ 15:
                    message.properties.push(FinancialPropertyBreakdown.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated kalos.analytics.v1.FinancialTimePeriod financial_periods */ 16:
                    message.financialPeriods.push(FinancialTimePeriod.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* double total_revenue = 1; */
        if (message.totalRevenue !== 0)
            writer.tag(1, WireType.Bit64).double(message.totalRevenue);
        /* double gross_profit = 2; */
        if (message.grossProfit !== 0)
            writer.tag(2, WireType.Bit64).double(message.grossProfit);
        /* double net_profit = 3; */
        if (message.netProfit !== 0)
            writer.tag(3, WireType.Bit64).double(message.netProfit);
        /* double billable_hours_percentage = 4; */
        if (message.billableHoursPercentage !== 0)
            writer.tag(4, WireType.Bit64).double(message.billableHoursPercentage);
        /* double revenue_per_labor_dollar = 5; */
        if (message.revenuePerLaborDollar !== 0)
            writer.tag(5, WireType.Bit64).double(message.revenuePerLaborDollar);
        /* double net_profit_per_hour = 6; */
        if (message.netProfitPerHour !== 0)
            writer.tag(6, WireType.Bit64).double(message.netProfitPerHour);
        /* double break_even_hourly_cost = 7; */
        if (message.breakEvenHourlyCost !== 0)
            writer.tag(7, WireType.Bit64).double(message.breakEvenHourlyCost);
        /* double average_job_value = 8; */
        if (message.averageJobValue !== 0)
            writer.tag(8, WireType.Bit64).double(message.averageJobValue);
        /* double gross_margin_percentage = 9; */
        if (message.grossMarginPercentage !== 0)
            writer.tag(9, WireType.Bit64).double(message.grossMarginPercentage);
        /* double net_margin_percentage = 10; */
        if (message.netMarginPercentage !== 0)
            writer.tag(10, WireType.Bit64).double(message.netMarginPercentage);
        /* repeated kalos.analytics.v1.FinancialDepartmentBreakdown departments = 11; */
        for (let i = 0; i < message.departments.length; i++)
            FinancialDepartmentBreakdown.internalBinaryWrite(message.departments[i], writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* kalos.analytics.v1.AccountsReceivableAging accounts_receivable = 12; */
        if (message.accountsReceivable)
            AccountsReceivableAging.internalBinaryWrite(message.accountsReceivable, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* repeated kalos.analytics.v1.TimeSeriesData time_series = 13; */
        for (let i = 0; i < message.timeSeries.length; i++)
            TimeSeriesData.internalBinaryWrite(message.timeSeries[i], writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* string calculated_at = 14; */
        if (message.calculatedAt !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.calculatedAt);
        /* repeated kalos.analytics.v1.FinancialPropertyBreakdown properties = 15; */
        for (let i = 0; i < message.properties.length; i++)
            FinancialPropertyBreakdown.internalBinaryWrite(message.properties[i], writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* repeated kalos.analytics.v1.FinancialTimePeriod financial_periods = 16; */
        for (let i = 0; i < message.financialPeriods.length; i++)
            FinancialTimePeriod.internalBinaryWrite(message.financialPeriods[i], writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.FinancialPerformanceMetricsResponse
 */
export const FinancialPerformanceMetricsResponse = new FinancialPerformanceMetricsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FinancialDepartmentBreakdown$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.FinancialDepartmentBreakdown", [
            { no: 1, name: "department_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "department_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "total_revenue", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "gross_profit", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "net_profit", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "gross_margin_percentage", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 7, name: "net_margin_percentage", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 8, name: "total_jobs", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "average_job_value", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 10, name: "total_labor_hours", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 11, name: "billable_hours_percentage", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 12, name: "job_types", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => FinancialJobTypeBreakdown },
            { no: 13, name: "trades", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => FinancialTradeBreakdown }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.departmentId = 0;
        message.departmentName = "";
        message.totalRevenue = 0;
        message.grossProfit = 0;
        message.netProfit = 0;
        message.grossMarginPercentage = 0;
        message.netMarginPercentage = 0;
        message.totalJobs = 0;
        message.averageJobValue = 0;
        message.totalLaborHours = 0;
        message.billableHoursPercentage = 0;
        message.jobTypes = [];
        message.trades = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 department_id */ 1:
                    message.departmentId = reader.int32();
                    break;
                case /* string department_name */ 2:
                    message.departmentName = reader.string();
                    break;
                case /* double total_revenue */ 3:
                    message.totalRevenue = reader.double();
                    break;
                case /* double gross_profit */ 4:
                    message.grossProfit = reader.double();
                    break;
                case /* double net_profit */ 5:
                    message.netProfit = reader.double();
                    break;
                case /* double gross_margin_percentage */ 6:
                    message.grossMarginPercentage = reader.double();
                    break;
                case /* double net_margin_percentage */ 7:
                    message.netMarginPercentage = reader.double();
                    break;
                case /* int32 total_jobs */ 8:
                    message.totalJobs = reader.int32();
                    break;
                case /* double average_job_value */ 9:
                    message.averageJobValue = reader.double();
                    break;
                case /* double total_labor_hours */ 10:
                    message.totalLaborHours = reader.double();
                    break;
                case /* double billable_hours_percentage */ 11:
                    message.billableHoursPercentage = reader.double();
                    break;
                case /* repeated kalos.analytics.v1.FinancialJobTypeBreakdown job_types */ 12:
                    message.jobTypes.push(FinancialJobTypeBreakdown.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated kalos.analytics.v1.FinancialTradeBreakdown trades */ 13:
                    message.trades.push(FinancialTradeBreakdown.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 department_id = 1; */
        if (message.departmentId !== 0)
            writer.tag(1, WireType.Varint).int32(message.departmentId);
        /* string department_name = 2; */
        if (message.departmentName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.departmentName);
        /* double total_revenue = 3; */
        if (message.totalRevenue !== 0)
            writer.tag(3, WireType.Bit64).double(message.totalRevenue);
        /* double gross_profit = 4; */
        if (message.grossProfit !== 0)
            writer.tag(4, WireType.Bit64).double(message.grossProfit);
        /* double net_profit = 5; */
        if (message.netProfit !== 0)
            writer.tag(5, WireType.Bit64).double(message.netProfit);
        /* double gross_margin_percentage = 6; */
        if (message.grossMarginPercentage !== 0)
            writer.tag(6, WireType.Bit64).double(message.grossMarginPercentage);
        /* double net_margin_percentage = 7; */
        if (message.netMarginPercentage !== 0)
            writer.tag(7, WireType.Bit64).double(message.netMarginPercentage);
        /* int32 total_jobs = 8; */
        if (message.totalJobs !== 0)
            writer.tag(8, WireType.Varint).int32(message.totalJobs);
        /* double average_job_value = 9; */
        if (message.averageJobValue !== 0)
            writer.tag(9, WireType.Bit64).double(message.averageJobValue);
        /* double total_labor_hours = 10; */
        if (message.totalLaborHours !== 0)
            writer.tag(10, WireType.Bit64).double(message.totalLaborHours);
        /* double billable_hours_percentage = 11; */
        if (message.billableHoursPercentage !== 0)
            writer.tag(11, WireType.Bit64).double(message.billableHoursPercentage);
        /* repeated kalos.analytics.v1.FinancialJobTypeBreakdown job_types = 12; */
        for (let i = 0; i < message.jobTypes.length; i++)
            FinancialJobTypeBreakdown.internalBinaryWrite(message.jobTypes[i], writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* repeated kalos.analytics.v1.FinancialTradeBreakdown trades = 13; */
        for (let i = 0; i < message.trades.length; i++)
            FinancialTradeBreakdown.internalBinaryWrite(message.trades[i], writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.FinancialDepartmentBreakdown
 */
export const FinancialDepartmentBreakdown = new FinancialDepartmentBreakdown$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FinancialTradeBreakdown$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.FinancialTradeBreakdown", [
            { no: 1, name: "event_trade_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "trade_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "total_revenue", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "gross_profit", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "net_profit", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "gross_margin_percentage", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 7, name: "net_margin_percentage", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 8, name: "total_jobs", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "average_job_value", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 10, name: "total_labor_hours", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 11, name: "billable_hours_percentage", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 12, name: "job_types", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => FinancialJobTypeBreakdown }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.eventTradeId = 0;
        message.tradeName = "";
        message.totalRevenue = 0;
        message.grossProfit = 0;
        message.netProfit = 0;
        message.grossMarginPercentage = 0;
        message.netMarginPercentage = 0;
        message.totalJobs = 0;
        message.averageJobValue = 0;
        message.totalLaborHours = 0;
        message.billableHoursPercentage = 0;
        message.jobTypes = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 event_trade_id */ 1:
                    message.eventTradeId = reader.int32();
                    break;
                case /* string trade_name */ 2:
                    message.tradeName = reader.string();
                    break;
                case /* double total_revenue */ 3:
                    message.totalRevenue = reader.double();
                    break;
                case /* double gross_profit */ 4:
                    message.grossProfit = reader.double();
                    break;
                case /* double net_profit */ 5:
                    message.netProfit = reader.double();
                    break;
                case /* double gross_margin_percentage */ 6:
                    message.grossMarginPercentage = reader.double();
                    break;
                case /* double net_margin_percentage */ 7:
                    message.netMarginPercentage = reader.double();
                    break;
                case /* int32 total_jobs */ 8:
                    message.totalJobs = reader.int32();
                    break;
                case /* double average_job_value */ 9:
                    message.averageJobValue = reader.double();
                    break;
                case /* double total_labor_hours */ 10:
                    message.totalLaborHours = reader.double();
                    break;
                case /* double billable_hours_percentage */ 11:
                    message.billableHoursPercentage = reader.double();
                    break;
                case /* repeated kalos.analytics.v1.FinancialJobTypeBreakdown job_types */ 12:
                    message.jobTypes.push(FinancialJobTypeBreakdown.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 event_trade_id = 1; */
        if (message.eventTradeId !== 0)
            writer.tag(1, WireType.Varint).int32(message.eventTradeId);
        /* string trade_name = 2; */
        if (message.tradeName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.tradeName);
        /* double total_revenue = 3; */
        if (message.totalRevenue !== 0)
            writer.tag(3, WireType.Bit64).double(message.totalRevenue);
        /* double gross_profit = 4; */
        if (message.grossProfit !== 0)
            writer.tag(4, WireType.Bit64).double(message.grossProfit);
        /* double net_profit = 5; */
        if (message.netProfit !== 0)
            writer.tag(5, WireType.Bit64).double(message.netProfit);
        /* double gross_margin_percentage = 6; */
        if (message.grossMarginPercentage !== 0)
            writer.tag(6, WireType.Bit64).double(message.grossMarginPercentage);
        /* double net_margin_percentage = 7; */
        if (message.netMarginPercentage !== 0)
            writer.tag(7, WireType.Bit64).double(message.netMarginPercentage);
        /* int32 total_jobs = 8; */
        if (message.totalJobs !== 0)
            writer.tag(8, WireType.Varint).int32(message.totalJobs);
        /* double average_job_value = 9; */
        if (message.averageJobValue !== 0)
            writer.tag(9, WireType.Bit64).double(message.averageJobValue);
        /* double total_labor_hours = 10; */
        if (message.totalLaborHours !== 0)
            writer.tag(10, WireType.Bit64).double(message.totalLaborHours);
        /* double billable_hours_percentage = 11; */
        if (message.billableHoursPercentage !== 0)
            writer.tag(11, WireType.Bit64).double(message.billableHoursPercentage);
        /* repeated kalos.analytics.v1.FinancialJobTypeBreakdown job_types = 12; */
        for (let i = 0; i < message.jobTypes.length; i++)
            FinancialJobTypeBreakdown.internalBinaryWrite(message.jobTypes[i], writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.FinancialTradeBreakdown
 */
export const FinancialTradeBreakdown = new FinancialTradeBreakdown$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FinancialJobTypeBreakdown$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.FinancialJobTypeBreakdown", [
            { no: 1, name: "job_type_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "job_type_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "total_revenue", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "gross_profit", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "net_profit", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "gross_margin_percentage", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 7, name: "net_margin_percentage", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 8, name: "total_jobs", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "average_job_value", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 10, name: "total_labor_hours", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 11, name: "billable_hours_percentage", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.jobTypeId = 0;
        message.jobTypeName = "";
        message.totalRevenue = 0;
        message.grossProfit = 0;
        message.netProfit = 0;
        message.grossMarginPercentage = 0;
        message.netMarginPercentage = 0;
        message.totalJobs = 0;
        message.averageJobValue = 0;
        message.totalLaborHours = 0;
        message.billableHoursPercentage = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 job_type_id */ 1:
                    message.jobTypeId = reader.int32();
                    break;
                case /* string job_type_name */ 2:
                    message.jobTypeName = reader.string();
                    break;
                case /* double total_revenue */ 3:
                    message.totalRevenue = reader.double();
                    break;
                case /* double gross_profit */ 4:
                    message.grossProfit = reader.double();
                    break;
                case /* double net_profit */ 5:
                    message.netProfit = reader.double();
                    break;
                case /* double gross_margin_percentage */ 6:
                    message.grossMarginPercentage = reader.double();
                    break;
                case /* double net_margin_percentage */ 7:
                    message.netMarginPercentage = reader.double();
                    break;
                case /* int32 total_jobs */ 8:
                    message.totalJobs = reader.int32();
                    break;
                case /* double average_job_value */ 9:
                    message.averageJobValue = reader.double();
                    break;
                case /* double total_labor_hours */ 10:
                    message.totalLaborHours = reader.double();
                    break;
                case /* double billable_hours_percentage */ 11:
                    message.billableHoursPercentage = reader.double();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 job_type_id = 1; */
        if (message.jobTypeId !== 0)
            writer.tag(1, WireType.Varint).int32(message.jobTypeId);
        /* string job_type_name = 2; */
        if (message.jobTypeName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.jobTypeName);
        /* double total_revenue = 3; */
        if (message.totalRevenue !== 0)
            writer.tag(3, WireType.Bit64).double(message.totalRevenue);
        /* double gross_profit = 4; */
        if (message.grossProfit !== 0)
            writer.tag(4, WireType.Bit64).double(message.grossProfit);
        /* double net_profit = 5; */
        if (message.netProfit !== 0)
            writer.tag(5, WireType.Bit64).double(message.netProfit);
        /* double gross_margin_percentage = 6; */
        if (message.grossMarginPercentage !== 0)
            writer.tag(6, WireType.Bit64).double(message.grossMarginPercentage);
        /* double net_margin_percentage = 7; */
        if (message.netMarginPercentage !== 0)
            writer.tag(7, WireType.Bit64).double(message.netMarginPercentage);
        /* int32 total_jobs = 8; */
        if (message.totalJobs !== 0)
            writer.tag(8, WireType.Varint).int32(message.totalJobs);
        /* double average_job_value = 9; */
        if (message.averageJobValue !== 0)
            writer.tag(9, WireType.Bit64).double(message.averageJobValue);
        /* double total_labor_hours = 10; */
        if (message.totalLaborHours !== 0)
            writer.tag(10, WireType.Bit64).double(message.totalLaborHours);
        /* double billable_hours_percentage = 11; */
        if (message.billableHoursPercentage !== 0)
            writer.tag(11, WireType.Bit64).double(message.billableHoursPercentage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.FinancialJobTypeBreakdown
 */
export const FinancialJobTypeBreakdown = new FinancialJobTypeBreakdown$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FinancialPropertyBreakdown$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.FinancialPropertyBreakdown", [
            { no: 1, name: "property_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "property_address", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "property_city", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "property_state", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "property_zip", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "total_revenue", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 7, name: "gross_profit", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 8, name: "net_profit", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 9, name: "gross_margin_percentage", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 10, name: "net_margin_percentage", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 11, name: "total_jobs", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 12, name: "average_job_value", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 13, name: "total_labor_hours", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 14, name: "billable_hours_percentage", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.propertyId = 0;
        message.propertyAddress = "";
        message.propertyCity = "";
        message.propertyState = "";
        message.propertyZip = "";
        message.totalRevenue = 0;
        message.grossProfit = 0;
        message.netProfit = 0;
        message.grossMarginPercentage = 0;
        message.netMarginPercentage = 0;
        message.totalJobs = 0;
        message.averageJobValue = 0;
        message.totalLaborHours = 0;
        message.billableHoursPercentage = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 property_id */ 1:
                    message.propertyId = reader.int32();
                    break;
                case /* string property_address */ 2:
                    message.propertyAddress = reader.string();
                    break;
                case /* string property_city */ 3:
                    message.propertyCity = reader.string();
                    break;
                case /* string property_state */ 4:
                    message.propertyState = reader.string();
                    break;
                case /* string property_zip */ 5:
                    message.propertyZip = reader.string();
                    break;
                case /* double total_revenue */ 6:
                    message.totalRevenue = reader.double();
                    break;
                case /* double gross_profit */ 7:
                    message.grossProfit = reader.double();
                    break;
                case /* double net_profit */ 8:
                    message.netProfit = reader.double();
                    break;
                case /* double gross_margin_percentage */ 9:
                    message.grossMarginPercentage = reader.double();
                    break;
                case /* double net_margin_percentage */ 10:
                    message.netMarginPercentage = reader.double();
                    break;
                case /* int32 total_jobs */ 11:
                    message.totalJobs = reader.int32();
                    break;
                case /* double average_job_value */ 12:
                    message.averageJobValue = reader.double();
                    break;
                case /* double total_labor_hours */ 13:
                    message.totalLaborHours = reader.double();
                    break;
                case /* double billable_hours_percentage */ 14:
                    message.billableHoursPercentage = reader.double();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 property_id = 1; */
        if (message.propertyId !== 0)
            writer.tag(1, WireType.Varint).int32(message.propertyId);
        /* string property_address = 2; */
        if (message.propertyAddress !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.propertyAddress);
        /* string property_city = 3; */
        if (message.propertyCity !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.propertyCity);
        /* string property_state = 4; */
        if (message.propertyState !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.propertyState);
        /* string property_zip = 5; */
        if (message.propertyZip !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.propertyZip);
        /* double total_revenue = 6; */
        if (message.totalRevenue !== 0)
            writer.tag(6, WireType.Bit64).double(message.totalRevenue);
        /* double gross_profit = 7; */
        if (message.grossProfit !== 0)
            writer.tag(7, WireType.Bit64).double(message.grossProfit);
        /* double net_profit = 8; */
        if (message.netProfit !== 0)
            writer.tag(8, WireType.Bit64).double(message.netProfit);
        /* double gross_margin_percentage = 9; */
        if (message.grossMarginPercentage !== 0)
            writer.tag(9, WireType.Bit64).double(message.grossMarginPercentage);
        /* double net_margin_percentage = 10; */
        if (message.netMarginPercentage !== 0)
            writer.tag(10, WireType.Bit64).double(message.netMarginPercentage);
        /* int32 total_jobs = 11; */
        if (message.totalJobs !== 0)
            writer.tag(11, WireType.Varint).int32(message.totalJobs);
        /* double average_job_value = 12; */
        if (message.averageJobValue !== 0)
            writer.tag(12, WireType.Bit64).double(message.averageJobValue);
        /* double total_labor_hours = 13; */
        if (message.totalLaborHours !== 0)
            writer.tag(13, WireType.Bit64).double(message.totalLaborHours);
        /* double billable_hours_percentage = 14; */
        if (message.billableHoursPercentage !== 0)
            writer.tag(14, WireType.Bit64).double(message.billableHoursPercentage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.FinancialPropertyBreakdown
 */
export const FinancialPropertyBreakdown = new FinancialPropertyBreakdown$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccountsReceivableAging$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.AccountsReceivableAging", [
            { no: 1, name: "total_outstanding", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "current", kind: "message", T: () => AccountsReceivableBucket },
            { no: 3, name: "days_1_30", kind: "message", T: () => AccountsReceivableBucket },
            { no: 4, name: "days_31_60", kind: "message", T: () => AccountsReceivableBucket },
            { no: 5, name: "days_61_90", kind: "message", T: () => AccountsReceivableBucket },
            { no: 6, name: "days_90_plus", kind: "message", T: () => AccountsReceivableBucket },
            { no: 7, name: "departments", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => DepartmentAccountsReceivable }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.totalOutstanding = 0;
        message.departments = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* double total_outstanding */ 1:
                    message.totalOutstanding = reader.double();
                    break;
                case /* kalos.analytics.v1.AccountsReceivableBucket current */ 2:
                    message.current = AccountsReceivableBucket.internalBinaryRead(reader, reader.uint32(), options, message.current);
                    break;
                case /* kalos.analytics.v1.AccountsReceivableBucket days_1_30 */ 3:
                    message.days130 = AccountsReceivableBucket.internalBinaryRead(reader, reader.uint32(), options, message.days130);
                    break;
                case /* kalos.analytics.v1.AccountsReceivableBucket days_31_60 */ 4:
                    message.days3160 = AccountsReceivableBucket.internalBinaryRead(reader, reader.uint32(), options, message.days3160);
                    break;
                case /* kalos.analytics.v1.AccountsReceivableBucket days_61_90 */ 5:
                    message.days6190 = AccountsReceivableBucket.internalBinaryRead(reader, reader.uint32(), options, message.days6190);
                    break;
                case /* kalos.analytics.v1.AccountsReceivableBucket days_90_plus */ 6:
                    message.days90Plus = AccountsReceivableBucket.internalBinaryRead(reader, reader.uint32(), options, message.days90Plus);
                    break;
                case /* repeated kalos.analytics.v1.DepartmentAccountsReceivable departments */ 7:
                    message.departments.push(DepartmentAccountsReceivable.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* double total_outstanding = 1; */
        if (message.totalOutstanding !== 0)
            writer.tag(1, WireType.Bit64).double(message.totalOutstanding);
        /* kalos.analytics.v1.AccountsReceivableBucket current = 2; */
        if (message.current)
            AccountsReceivableBucket.internalBinaryWrite(message.current, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* kalos.analytics.v1.AccountsReceivableBucket days_1_30 = 3; */
        if (message.days130)
            AccountsReceivableBucket.internalBinaryWrite(message.days130, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* kalos.analytics.v1.AccountsReceivableBucket days_31_60 = 4; */
        if (message.days3160)
            AccountsReceivableBucket.internalBinaryWrite(message.days3160, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* kalos.analytics.v1.AccountsReceivableBucket days_61_90 = 5; */
        if (message.days6190)
            AccountsReceivableBucket.internalBinaryWrite(message.days6190, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* kalos.analytics.v1.AccountsReceivableBucket days_90_plus = 6; */
        if (message.days90Plus)
            AccountsReceivableBucket.internalBinaryWrite(message.days90Plus, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* repeated kalos.analytics.v1.DepartmentAccountsReceivable departments = 7; */
        for (let i = 0; i < message.departments.length; i++)
            DepartmentAccountsReceivable.internalBinaryWrite(message.departments[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.AccountsReceivableAging
 */
export const AccountsReceivableAging = new AccountsReceivableAging$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccountsReceivableBucket$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.AccountsReceivableBucket", [
            { no: 1, name: "amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "percentage_of_total", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "invoice_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.amount = 0;
        message.percentageOfTotal = 0;
        message.invoiceCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* double amount */ 1:
                    message.amount = reader.double();
                    break;
                case /* double percentage_of_total */ 2:
                    message.percentageOfTotal = reader.double();
                    break;
                case /* int32 invoice_count */ 3:
                    message.invoiceCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* double amount = 1; */
        if (message.amount !== 0)
            writer.tag(1, WireType.Bit64).double(message.amount);
        /* double percentage_of_total = 2; */
        if (message.percentageOfTotal !== 0)
            writer.tag(2, WireType.Bit64).double(message.percentageOfTotal);
        /* int32 invoice_count = 3; */
        if (message.invoiceCount !== 0)
            writer.tag(3, WireType.Varint).int32(message.invoiceCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.AccountsReceivableBucket
 */
export const AccountsReceivableBucket = new AccountsReceivableBucket$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DepartmentAccountsReceivable$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.DepartmentAccountsReceivable", [
            { no: 1, name: "department_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "department_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "total_outstanding", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "current", kind: "message", T: () => AccountsReceivableBucket },
            { no: 5, name: "days_1_30", kind: "message", T: () => AccountsReceivableBucket },
            { no: 6, name: "days_31_60", kind: "message", T: () => AccountsReceivableBucket },
            { no: 7, name: "days_61_90", kind: "message", T: () => AccountsReceivableBucket },
            { no: 8, name: "days_90_plus", kind: "message", T: () => AccountsReceivableBucket }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.departmentId = 0;
        message.departmentName = "";
        message.totalOutstanding = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 department_id */ 1:
                    message.departmentId = reader.int32();
                    break;
                case /* string department_name */ 2:
                    message.departmentName = reader.string();
                    break;
                case /* double total_outstanding */ 3:
                    message.totalOutstanding = reader.double();
                    break;
                case /* kalos.analytics.v1.AccountsReceivableBucket current */ 4:
                    message.current = AccountsReceivableBucket.internalBinaryRead(reader, reader.uint32(), options, message.current);
                    break;
                case /* kalos.analytics.v1.AccountsReceivableBucket days_1_30 */ 5:
                    message.days130 = AccountsReceivableBucket.internalBinaryRead(reader, reader.uint32(), options, message.days130);
                    break;
                case /* kalos.analytics.v1.AccountsReceivableBucket days_31_60 */ 6:
                    message.days3160 = AccountsReceivableBucket.internalBinaryRead(reader, reader.uint32(), options, message.days3160);
                    break;
                case /* kalos.analytics.v1.AccountsReceivableBucket days_61_90 */ 7:
                    message.days6190 = AccountsReceivableBucket.internalBinaryRead(reader, reader.uint32(), options, message.days6190);
                    break;
                case /* kalos.analytics.v1.AccountsReceivableBucket days_90_plus */ 8:
                    message.days90Plus = AccountsReceivableBucket.internalBinaryRead(reader, reader.uint32(), options, message.days90Plus);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 department_id = 1; */
        if (message.departmentId !== 0)
            writer.tag(1, WireType.Varint).int32(message.departmentId);
        /* string department_name = 2; */
        if (message.departmentName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.departmentName);
        /* double total_outstanding = 3; */
        if (message.totalOutstanding !== 0)
            writer.tag(3, WireType.Bit64).double(message.totalOutstanding);
        /* kalos.analytics.v1.AccountsReceivableBucket current = 4; */
        if (message.current)
            AccountsReceivableBucket.internalBinaryWrite(message.current, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* kalos.analytics.v1.AccountsReceivableBucket days_1_30 = 5; */
        if (message.days130)
            AccountsReceivableBucket.internalBinaryWrite(message.days130, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* kalos.analytics.v1.AccountsReceivableBucket days_31_60 = 6; */
        if (message.days3160)
            AccountsReceivableBucket.internalBinaryWrite(message.days3160, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* kalos.analytics.v1.AccountsReceivableBucket days_61_90 = 7; */
        if (message.days6190)
            AccountsReceivableBucket.internalBinaryWrite(message.days6190, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* kalos.analytics.v1.AccountsReceivableBucket days_90_plus = 8; */
        if (message.days90Plus)
            AccountsReceivableBucket.internalBinaryWrite(message.days90Plus, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.DepartmentAccountsReceivable
 */
export const DepartmentAccountsReceivable = new DepartmentAccountsReceivable$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PricingMetricsRequest$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.PricingMetricsRequest", [
            { no: 1, name: "filter", kind: "message", T: () => StandardMetricsFilter },
            { no: 2, name: "include_time_series", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "time_granularity", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.includeTimeSeries = false;
        message.timeGranularity = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* kalos.analytics.v1.StandardMetricsFilter filter */ 1:
                    message.filter = StandardMetricsFilter.internalBinaryRead(reader, reader.uint32(), options, message.filter);
                    break;
                case /* bool include_time_series */ 2:
                    message.includeTimeSeries = reader.bool();
                    break;
                case /* string time_granularity */ 3:
                    message.timeGranularity = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* kalos.analytics.v1.StandardMetricsFilter filter = 1; */
        if (message.filter)
            StandardMetricsFilter.internalBinaryWrite(message.filter, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool include_time_series = 2; */
        if (message.includeTimeSeries !== false)
            writer.tag(2, WireType.Varint).bool(message.includeTimeSeries);
        /* string time_granularity = 3; */
        if (message.timeGranularity !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.timeGranularity);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.PricingMetricsRequest
 */
export const PricingMetricsRequest = new PricingMetricsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PricingMetricsResponse$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.PricingMetricsResponse", [
            { no: 1, name: "job_volume", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "volume_of_sales_sheets", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 12, name: "total_proposals", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "conversion_of_sales_sheets", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "average_job_duration_hours", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "average_drive_time_minutes", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "unsigned_proposals_sent", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "jobs_without_proposals", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "recent_jobs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => JobProfitabilityItem },
            { no: 9, name: "departments", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PricingDepartmentBreakdown },
            { no: 10, name: "time_series", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TimeSeriesData },
            { no: 11, name: "calculated_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.jobVolume = 0;
        message.volumeOfSalesSheets = 0;
        message.totalProposals = 0;
        message.conversionOfSalesSheets = 0;
        message.averageJobDurationHours = 0;
        message.averageDriveTimeMinutes = 0;
        message.unsignedProposalsSent = 0;
        message.jobsWithoutProposals = 0;
        message.recentJobs = [];
        message.departments = [];
        message.timeSeries = [];
        message.calculatedAt = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 job_volume */ 1:
                    message.jobVolume = reader.int32();
                    break;
                case /* int32 volume_of_sales_sheets */ 2:
                    message.volumeOfSalesSheets = reader.int32();
                    break;
                case /* int32 total_proposals */ 12:
                    message.totalProposals = reader.int32();
                    break;
                case /* double conversion_of_sales_sheets */ 3:
                    message.conversionOfSalesSheets = reader.double();
                    break;
                case /* double average_job_duration_hours */ 4:
                    message.averageJobDurationHours = reader.double();
                    break;
                case /* double average_drive_time_minutes */ 5:
                    message.averageDriveTimeMinutes = reader.double();
                    break;
                case /* int32 unsigned_proposals_sent */ 6:
                    message.unsignedProposalsSent = reader.int32();
                    break;
                case /* int32 jobs_without_proposals */ 7:
                    message.jobsWithoutProposals = reader.int32();
                    break;
                case /* repeated kalos.analytics.v1.JobProfitabilityItem recent_jobs */ 8:
                    message.recentJobs.push(JobProfitabilityItem.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated kalos.analytics.v1.PricingDepartmentBreakdown departments */ 9:
                    message.departments.push(PricingDepartmentBreakdown.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated kalos.analytics.v1.TimeSeriesData time_series */ 10:
                    message.timeSeries.push(TimeSeriesData.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string calculated_at */ 11:
                    message.calculatedAt = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 job_volume = 1; */
        if (message.jobVolume !== 0)
            writer.tag(1, WireType.Varint).int32(message.jobVolume);
        /* int32 volume_of_sales_sheets = 2; */
        if (message.volumeOfSalesSheets !== 0)
            writer.tag(2, WireType.Varint).int32(message.volumeOfSalesSheets);
        /* double conversion_of_sales_sheets = 3; */
        if (message.conversionOfSalesSheets !== 0)
            writer.tag(3, WireType.Bit64).double(message.conversionOfSalesSheets);
        /* double average_job_duration_hours = 4; */
        if (message.averageJobDurationHours !== 0)
            writer.tag(4, WireType.Bit64).double(message.averageJobDurationHours);
        /* double average_drive_time_minutes = 5; */
        if (message.averageDriveTimeMinutes !== 0)
            writer.tag(5, WireType.Bit64).double(message.averageDriveTimeMinutes);
        /* int32 unsigned_proposals_sent = 6; */
        if (message.unsignedProposalsSent !== 0)
            writer.tag(6, WireType.Varint).int32(message.unsignedProposalsSent);
        /* int32 jobs_without_proposals = 7; */
        if (message.jobsWithoutProposals !== 0)
            writer.tag(7, WireType.Varint).int32(message.jobsWithoutProposals);
        /* repeated kalos.analytics.v1.JobProfitabilityItem recent_jobs = 8; */
        for (let i = 0; i < message.recentJobs.length; i++)
            JobProfitabilityItem.internalBinaryWrite(message.recentJobs[i], writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* repeated kalos.analytics.v1.PricingDepartmentBreakdown departments = 9; */
        for (let i = 0; i < message.departments.length; i++)
            PricingDepartmentBreakdown.internalBinaryWrite(message.departments[i], writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* repeated kalos.analytics.v1.TimeSeriesData time_series = 10; */
        for (let i = 0; i < message.timeSeries.length; i++)
            TimeSeriesData.internalBinaryWrite(message.timeSeries[i], writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* string calculated_at = 11; */
        if (message.calculatedAt !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.calculatedAt);
        /* int32 total_proposals = 12; */
        if (message.totalProposals !== 0)
            writer.tag(12, WireType.Varint).int32(message.totalProposals);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.PricingMetricsResponse
 */
export const PricingMetricsResponse = new PricingMetricsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PricingDepartmentBreakdown$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.PricingDepartmentBreakdown", [
            { no: 1, name: "department_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "department_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "job_volume", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "volume_of_sales_sheets", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "conversion_of_sales_sheets", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "average_job_duration_hours", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 7, name: "average_drive_time_minutes", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 8, name: "unsigned_proposals_sent", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "jobs_without_proposals", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "job_types", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PricingJobTypeBreakdown },
            { no: 11, name: "total_proposals", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 12, name: "trades", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PricingTradeBreakdown }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.departmentId = 0;
        message.departmentName = "";
        message.jobVolume = 0;
        message.volumeOfSalesSheets = 0;
        message.conversionOfSalesSheets = 0;
        message.averageJobDurationHours = 0;
        message.averageDriveTimeMinutes = 0;
        message.unsignedProposalsSent = 0;
        message.jobsWithoutProposals = 0;
        message.jobTypes = [];
        message.totalProposals = 0;
        message.trades = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 department_id */ 1:
                    message.departmentId = reader.int32();
                    break;
                case /* string department_name */ 2:
                    message.departmentName = reader.string();
                    break;
                case /* int32 job_volume */ 3:
                    message.jobVolume = reader.int32();
                    break;
                case /* int32 volume_of_sales_sheets */ 4:
                    message.volumeOfSalesSheets = reader.int32();
                    break;
                case /* double conversion_of_sales_sheets */ 5:
                    message.conversionOfSalesSheets = reader.double();
                    break;
                case /* double average_job_duration_hours */ 6:
                    message.averageJobDurationHours = reader.double();
                    break;
                case /* double average_drive_time_minutes */ 7:
                    message.averageDriveTimeMinutes = reader.double();
                    break;
                case /* int32 unsigned_proposals_sent */ 8:
                    message.unsignedProposalsSent = reader.int32();
                    break;
                case /* int32 jobs_without_proposals */ 9:
                    message.jobsWithoutProposals = reader.int32();
                    break;
                case /* repeated kalos.analytics.v1.PricingJobTypeBreakdown job_types */ 10:
                    message.jobTypes.push(PricingJobTypeBreakdown.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_proposals */ 11:
                    message.totalProposals = reader.int32();
                    break;
                case /* repeated kalos.analytics.v1.PricingTradeBreakdown trades */ 12:
                    message.trades.push(PricingTradeBreakdown.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 department_id = 1; */
        if (message.departmentId !== 0)
            writer.tag(1, WireType.Varint).int32(message.departmentId);
        /* string department_name = 2; */
        if (message.departmentName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.departmentName);
        /* int32 job_volume = 3; */
        if (message.jobVolume !== 0)
            writer.tag(3, WireType.Varint).int32(message.jobVolume);
        /* int32 volume_of_sales_sheets = 4; */
        if (message.volumeOfSalesSheets !== 0)
            writer.tag(4, WireType.Varint).int32(message.volumeOfSalesSheets);
        /* double conversion_of_sales_sheets = 5; */
        if (message.conversionOfSalesSheets !== 0)
            writer.tag(5, WireType.Bit64).double(message.conversionOfSalesSheets);
        /* double average_job_duration_hours = 6; */
        if (message.averageJobDurationHours !== 0)
            writer.tag(6, WireType.Bit64).double(message.averageJobDurationHours);
        /* double average_drive_time_minutes = 7; */
        if (message.averageDriveTimeMinutes !== 0)
            writer.tag(7, WireType.Bit64).double(message.averageDriveTimeMinutes);
        /* int32 unsigned_proposals_sent = 8; */
        if (message.unsignedProposalsSent !== 0)
            writer.tag(8, WireType.Varint).int32(message.unsignedProposalsSent);
        /* int32 jobs_without_proposals = 9; */
        if (message.jobsWithoutProposals !== 0)
            writer.tag(9, WireType.Varint).int32(message.jobsWithoutProposals);
        /* repeated kalos.analytics.v1.PricingJobTypeBreakdown job_types = 10; */
        for (let i = 0; i < message.jobTypes.length; i++)
            PricingJobTypeBreakdown.internalBinaryWrite(message.jobTypes[i], writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_proposals = 11; */
        if (message.totalProposals !== 0)
            writer.tag(11, WireType.Varint).int32(message.totalProposals);
        /* repeated kalos.analytics.v1.PricingTradeBreakdown trades = 12; */
        for (let i = 0; i < message.trades.length; i++)
            PricingTradeBreakdown.internalBinaryWrite(message.trades[i], writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.PricingDepartmentBreakdown
 */
export const PricingDepartmentBreakdown = new PricingDepartmentBreakdown$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PricingTradeBreakdown$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.PricingTradeBreakdown", [
            { no: 1, name: "event_trade_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "trade_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "job_volume", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "volume_of_sales_sheets", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "conversion_of_sales_sheets", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "average_job_duration_hours", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 7, name: "average_drive_time_minutes", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 8, name: "unsigned_proposals_sent", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "jobs_without_proposals", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "job_types", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PricingJobTypeBreakdown },
            { no: 11, name: "total_proposals", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.eventTradeId = 0;
        message.tradeName = "";
        message.jobVolume = 0;
        message.volumeOfSalesSheets = 0;
        message.conversionOfSalesSheets = 0;
        message.averageJobDurationHours = 0;
        message.averageDriveTimeMinutes = 0;
        message.unsignedProposalsSent = 0;
        message.jobsWithoutProposals = 0;
        message.jobTypes = [];
        message.totalProposals = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 event_trade_id */ 1:
                    message.eventTradeId = reader.int32();
                    break;
                case /* string trade_name */ 2:
                    message.tradeName = reader.string();
                    break;
                case /* int32 job_volume */ 3:
                    message.jobVolume = reader.int32();
                    break;
                case /* int32 volume_of_sales_sheets */ 4:
                    message.volumeOfSalesSheets = reader.int32();
                    break;
                case /* double conversion_of_sales_sheets */ 5:
                    message.conversionOfSalesSheets = reader.double();
                    break;
                case /* double average_job_duration_hours */ 6:
                    message.averageJobDurationHours = reader.double();
                    break;
                case /* double average_drive_time_minutes */ 7:
                    message.averageDriveTimeMinutes = reader.double();
                    break;
                case /* int32 unsigned_proposals_sent */ 8:
                    message.unsignedProposalsSent = reader.int32();
                    break;
                case /* int32 jobs_without_proposals */ 9:
                    message.jobsWithoutProposals = reader.int32();
                    break;
                case /* repeated kalos.analytics.v1.PricingJobTypeBreakdown job_types */ 10:
                    message.jobTypes.push(PricingJobTypeBreakdown.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_proposals */ 11:
                    message.totalProposals = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 event_trade_id = 1; */
        if (message.eventTradeId !== 0)
            writer.tag(1, WireType.Varint).int32(message.eventTradeId);
        /* string trade_name = 2; */
        if (message.tradeName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.tradeName);
        /* int32 job_volume = 3; */
        if (message.jobVolume !== 0)
            writer.tag(3, WireType.Varint).int32(message.jobVolume);
        /* int32 volume_of_sales_sheets = 4; */
        if (message.volumeOfSalesSheets !== 0)
            writer.tag(4, WireType.Varint).int32(message.volumeOfSalesSheets);
        /* double conversion_of_sales_sheets = 5; */
        if (message.conversionOfSalesSheets !== 0)
            writer.tag(5, WireType.Bit64).double(message.conversionOfSalesSheets);
        /* double average_job_duration_hours = 6; */
        if (message.averageJobDurationHours !== 0)
            writer.tag(6, WireType.Bit64).double(message.averageJobDurationHours);
        /* double average_drive_time_minutes = 7; */
        if (message.averageDriveTimeMinutes !== 0)
            writer.tag(7, WireType.Bit64).double(message.averageDriveTimeMinutes);
        /* int32 unsigned_proposals_sent = 8; */
        if (message.unsignedProposalsSent !== 0)
            writer.tag(8, WireType.Varint).int32(message.unsignedProposalsSent);
        /* int32 jobs_without_proposals = 9; */
        if (message.jobsWithoutProposals !== 0)
            writer.tag(9, WireType.Varint).int32(message.jobsWithoutProposals);
        /* repeated kalos.analytics.v1.PricingJobTypeBreakdown job_types = 10; */
        for (let i = 0; i < message.jobTypes.length; i++)
            PricingJobTypeBreakdown.internalBinaryWrite(message.jobTypes[i], writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_proposals = 11; */
        if (message.totalProposals !== 0)
            writer.tag(11, WireType.Varint).int32(message.totalProposals);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.PricingTradeBreakdown
 */
export const PricingTradeBreakdown = new PricingTradeBreakdown$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PricingJobTypeBreakdown$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.PricingJobTypeBreakdown", [
            { no: 1, name: "job_type_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "job_type_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "job_volume", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "volume_of_sales_sheets", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "conversion_of_sales_sheets", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "average_job_duration_hours", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 7, name: "average_drive_time_minutes", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 8, name: "unsigned_proposals_sent", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "jobs_without_proposals", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "total_proposals", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.jobTypeId = 0;
        message.jobTypeName = "";
        message.jobVolume = 0;
        message.volumeOfSalesSheets = 0;
        message.conversionOfSalesSheets = 0;
        message.averageJobDurationHours = 0;
        message.averageDriveTimeMinutes = 0;
        message.unsignedProposalsSent = 0;
        message.jobsWithoutProposals = 0;
        message.totalProposals = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 job_type_id */ 1:
                    message.jobTypeId = reader.int32();
                    break;
                case /* string job_type_name */ 2:
                    message.jobTypeName = reader.string();
                    break;
                case /* int32 job_volume */ 3:
                    message.jobVolume = reader.int32();
                    break;
                case /* int32 volume_of_sales_sheets */ 4:
                    message.volumeOfSalesSheets = reader.int32();
                    break;
                case /* double conversion_of_sales_sheets */ 5:
                    message.conversionOfSalesSheets = reader.double();
                    break;
                case /* double average_job_duration_hours */ 6:
                    message.averageJobDurationHours = reader.double();
                    break;
                case /* double average_drive_time_minutes */ 7:
                    message.averageDriveTimeMinutes = reader.double();
                    break;
                case /* int32 unsigned_proposals_sent */ 8:
                    message.unsignedProposalsSent = reader.int32();
                    break;
                case /* int32 jobs_without_proposals */ 9:
                    message.jobsWithoutProposals = reader.int32();
                    break;
                case /* int32 total_proposals */ 10:
                    message.totalProposals = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 job_type_id = 1; */
        if (message.jobTypeId !== 0)
            writer.tag(1, WireType.Varint).int32(message.jobTypeId);
        /* string job_type_name = 2; */
        if (message.jobTypeName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.jobTypeName);
        /* int32 job_volume = 3; */
        if (message.jobVolume !== 0)
            writer.tag(3, WireType.Varint).int32(message.jobVolume);
        /* int32 volume_of_sales_sheets = 4; */
        if (message.volumeOfSalesSheets !== 0)
            writer.tag(4, WireType.Varint).int32(message.volumeOfSalesSheets);
        /* double conversion_of_sales_sheets = 5; */
        if (message.conversionOfSalesSheets !== 0)
            writer.tag(5, WireType.Bit64).double(message.conversionOfSalesSheets);
        /* double average_job_duration_hours = 6; */
        if (message.averageJobDurationHours !== 0)
            writer.tag(6, WireType.Bit64).double(message.averageJobDurationHours);
        /* double average_drive_time_minutes = 7; */
        if (message.averageDriveTimeMinutes !== 0)
            writer.tag(7, WireType.Bit64).double(message.averageDriveTimeMinutes);
        /* int32 unsigned_proposals_sent = 8; */
        if (message.unsignedProposalsSent !== 0)
            writer.tag(8, WireType.Varint).int32(message.unsignedProposalsSent);
        /* int32 jobs_without_proposals = 9; */
        if (message.jobsWithoutProposals !== 0)
            writer.tag(9, WireType.Varint).int32(message.jobsWithoutProposals);
        /* int32 total_proposals = 10; */
        if (message.totalProposals !== 0)
            writer.tag(10, WireType.Varint).int32(message.totalProposals);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.PricingJobTypeBreakdown
 */
export const PricingJobTypeBreakdown = new PricingJobTypeBreakdown$Type();
// @generated message type with reflection information, may provide speed optimized methods
class JobProfitabilityRequest$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.JobProfitabilityRequest", [
            { no: 1, name: "filter", kind: "message", T: () => StandardMetricsFilter },
            { no: 2, name: "pagination", kind: "message", T: () => PaginationRequest },
            { no: 3, name: "search_query", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.searchQuery = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* kalos.analytics.v1.StandardMetricsFilter filter */ 1:
                    message.filter = StandardMetricsFilter.internalBinaryRead(reader, reader.uint32(), options, message.filter);
                    break;
                case /* kalos.analytics.v1.PaginationRequest pagination */ 2:
                    message.pagination = PaginationRequest.internalBinaryRead(reader, reader.uint32(), options, message.pagination);
                    break;
                case /* string search_query */ 3:
                    message.searchQuery = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* kalos.analytics.v1.StandardMetricsFilter filter = 1; */
        if (message.filter)
            StandardMetricsFilter.internalBinaryWrite(message.filter, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* kalos.analytics.v1.PaginationRequest pagination = 2; */
        if (message.pagination)
            PaginationRequest.internalBinaryWrite(message.pagination, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string search_query = 3; */
        if (message.searchQuery !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.searchQuery);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.JobProfitabilityRequest
 */
export const JobProfitabilityRequest = new JobProfitabilityRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class JobProfitabilityResponse$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.JobProfitabilityResponse", [
            { no: 1, name: "jobs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => JobProfitabilityItem },
            { no: 2, name: "pagination", kind: "message", T: () => PaginationResponse }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.jobs = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated kalos.analytics.v1.JobProfitabilityItem jobs */ 1:
                    message.jobs.push(JobProfitabilityItem.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* kalos.analytics.v1.PaginationResponse pagination */ 2:
                    message.pagination = PaginationResponse.internalBinaryRead(reader, reader.uint32(), options, message.pagination);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated kalos.analytics.v1.JobProfitabilityItem jobs = 1; */
        for (let i = 0; i < message.jobs.length; i++)
            JobProfitabilityItem.internalBinaryWrite(message.jobs[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* kalos.analytics.v1.PaginationResponse pagination = 2; */
        if (message.pagination)
            PaginationResponse.internalBinaryWrite(message.pagination, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.JobProfitabilityResponse
 */
export const JobProfitabilityResponse = new JobProfitabilityResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BlockedJobsRequest$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.BlockedJobsRequest", [
            { no: 1, name: "filter", kind: "message", T: () => StandardMetricsFilter },
            { no: 2, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.limit = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* kalos.analytics.v1.StandardMetricsFilter filter */ 1:
                    message.filter = StandardMetricsFilter.internalBinaryRead(reader, reader.uint32(), options, message.filter);
                    break;
                case /* int32 limit */ 2:
                    message.limit = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* kalos.analytics.v1.StandardMetricsFilter filter = 1; */
        if (message.filter)
            StandardMetricsFilter.internalBinaryWrite(message.filter, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 limit = 2; */
        if (message.limit !== 0)
            writer.tag(2, WireType.Varint).int32(message.limit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.BlockedJobsRequest
 */
export const BlockedJobsRequest = new BlockedJobsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BlockedJobsResponse$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.BlockedJobsResponse", [
            { no: 1, name: "jobs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => BlockedJobItem },
            { no: 2, name: "total_blocked_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.jobs = [];
        message.totalBlockedCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated kalos.analytics.v1.BlockedJobItem jobs */ 1:
                    message.jobs.push(BlockedJobItem.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_blocked_count */ 2:
                    message.totalBlockedCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated kalos.analytics.v1.BlockedJobItem jobs = 1; */
        for (let i = 0; i < message.jobs.length; i++)
            BlockedJobItem.internalBinaryWrite(message.jobs[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_blocked_count = 2; */
        if (message.totalBlockedCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalBlockedCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.BlockedJobsResponse
 */
export const BlockedJobsResponse = new BlockedJobsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BlockedJobItem$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.BlockedJobItem", [
            { no: 1, name: "job_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "job_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "job_status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "department_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "job_type_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "revenue", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 7, name: "days_in_status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "customer_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "department_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "job_type_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "property_address", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.jobId = 0;
        message.jobNumber = "";
        message.jobStatus = "";
        message.departmentName = "";
        message.jobTypeName = "";
        message.revenue = 0;
        message.daysInStatus = 0;
        message.customerName = "";
        message.departmentId = 0;
        message.jobTypeId = 0;
        message.propertyAddress = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 job_id */ 1:
                    message.jobId = reader.int32();
                    break;
                case /* string job_number */ 2:
                    message.jobNumber = reader.string();
                    break;
                case /* string job_status */ 3:
                    message.jobStatus = reader.string();
                    break;
                case /* string department_name */ 4:
                    message.departmentName = reader.string();
                    break;
                case /* string job_type_name */ 5:
                    message.jobTypeName = reader.string();
                    break;
                case /* double revenue */ 6:
                    message.revenue = reader.double();
                    break;
                case /* int32 days_in_status */ 7:
                    message.daysInStatus = reader.int32();
                    break;
                case /* string customer_name */ 8:
                    message.customerName = reader.string();
                    break;
                case /* int32 department_id */ 9:
                    message.departmentId = reader.int32();
                    break;
                case /* int32 job_type_id */ 10:
                    message.jobTypeId = reader.int32();
                    break;
                case /* string property_address */ 11:
                    message.propertyAddress = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 job_id = 1; */
        if (message.jobId !== 0)
            writer.tag(1, WireType.Varint).int32(message.jobId);
        /* string job_number = 2; */
        if (message.jobNumber !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.jobNumber);
        /* string job_status = 3; */
        if (message.jobStatus !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.jobStatus);
        /* string department_name = 4; */
        if (message.departmentName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.departmentName);
        /* string job_type_name = 5; */
        if (message.jobTypeName !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.jobTypeName);
        /* double revenue = 6; */
        if (message.revenue !== 0)
            writer.tag(6, WireType.Bit64).double(message.revenue);
        /* int32 days_in_status = 7; */
        if (message.daysInStatus !== 0)
            writer.tag(7, WireType.Varint).int32(message.daysInStatus);
        /* string customer_name = 8; */
        if (message.customerName !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.customerName);
        /* int32 department_id = 9; */
        if (message.departmentId !== 0)
            writer.tag(9, WireType.Varint).int32(message.departmentId);
        /* int32 job_type_id = 10; */
        if (message.jobTypeId !== 0)
            writer.tag(10, WireType.Varint).int32(message.jobTypeId);
        /* string property_address = 11; */
        if (message.propertyAddress !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.propertyAddress);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.BlockedJobItem
 */
export const BlockedJobItem = new BlockedJobItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class JobStatusBreakdownRequest$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.JobStatusBreakdownRequest", [
            { no: 1, name: "filter", kind: "message", T: () => StandardMetricsFilter },
            { no: 2, name: "group_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.groupBy = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* kalos.analytics.v1.StandardMetricsFilter filter */ 1:
                    message.filter = StandardMetricsFilter.internalBinaryRead(reader, reader.uint32(), options, message.filter);
                    break;
                case /* string group_by */ 2:
                    message.groupBy = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* kalos.analytics.v1.StandardMetricsFilter filter = 1; */
        if (message.filter)
            StandardMetricsFilter.internalBinaryWrite(message.filter, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string group_by = 2; */
        if (message.groupBy !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.groupBy);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.JobStatusBreakdownRequest
 */
export const JobStatusBreakdownRequest = new JobStatusBreakdownRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class JobStatusBreakdownResponse$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.JobStatusBreakdownResponse", [
            { no: 1, name: "breakdown", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => JobStatusBreakdownItem },
            { no: 2, name: "calculated_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.breakdown = [];
        message.calculatedAt = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated kalos.analytics.v1.JobStatusBreakdownItem breakdown */ 1:
                    message.breakdown.push(JobStatusBreakdownItem.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string calculated_at */ 2:
                    message.calculatedAt = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated kalos.analytics.v1.JobStatusBreakdownItem breakdown = 1; */
        for (let i = 0; i < message.breakdown.length; i++)
            JobStatusBreakdownItem.internalBinaryWrite(message.breakdown[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string calculated_at = 2; */
        if (message.calculatedAt !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.calculatedAt);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.JobStatusBreakdownResponse
 */
export const JobStatusBreakdownResponse = new JobStatusBreakdownResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class JobStatusBreakdownItem$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.JobStatusBreakdownItem", [
            { no: 1, name: "group_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "group_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "open_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "active_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "blocked_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "completed_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.groupName = "";
        message.groupId = 0;
        message.openCount = 0;
        message.activeCount = 0;
        message.blockedCount = 0;
        message.completedCount = 0;
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string group_name */ 1:
                    message.groupName = reader.string();
                    break;
                case /* int32 group_id */ 2:
                    message.groupId = reader.int32();
                    break;
                case /* int32 open_count */ 3:
                    message.openCount = reader.int32();
                    break;
                case /* int32 active_count */ 4:
                    message.activeCount = reader.int32();
                    break;
                case /* int32 blocked_count */ 5:
                    message.blockedCount = reader.int32();
                    break;
                case /* int32 completed_count */ 6:
                    message.completedCount = reader.int32();
                    break;
                case /* int32 total_count */ 7:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string group_name = 1; */
        if (message.groupName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.groupName);
        /* int32 group_id = 2; */
        if (message.groupId !== 0)
            writer.tag(2, WireType.Varint).int32(message.groupId);
        /* int32 open_count = 3; */
        if (message.openCount !== 0)
            writer.tag(3, WireType.Varint).int32(message.openCount);
        /* int32 active_count = 4; */
        if (message.activeCount !== 0)
            writer.tag(4, WireType.Varint).int32(message.activeCount);
        /* int32 blocked_count = 5; */
        if (message.blockedCount !== 0)
            writer.tag(5, WireType.Varint).int32(message.blockedCount);
        /* int32 completed_count = 6; */
        if (message.completedCount !== 0)
            writer.tag(6, WireType.Varint).int32(message.completedCount);
        /* int32 total_count = 7; */
        if (message.totalCount !== 0)
            writer.tag(7, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.JobStatusBreakdownItem
 */
export const JobStatusBreakdownItem = new JobStatusBreakdownItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class JobProgressKPIsRequest$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.JobProgressKPIsRequest", [
            { no: 1, name: "filter", kind: "message", T: () => StandardMetricsFilter }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* kalos.analytics.v1.StandardMetricsFilter filter */ 1:
                    message.filter = StandardMetricsFilter.internalBinaryRead(reader, reader.uint32(), options, message.filter);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* kalos.analytics.v1.StandardMetricsFilter filter = 1; */
        if (message.filter)
            StandardMetricsFilter.internalBinaryWrite(message.filter, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.JobProgressKPIsRequest
 */
export const JobProgressKPIsRequest = new JobProgressKPIsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class JobProgressKPIsResponse$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.JobProgressKPIsResponse", [
            { no: 1, name: "open_jobs_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "active_jobs_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "blocked_jobs_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "total_wip_value", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "average_open_job_age_days", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "calculated_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.openJobsCount = 0;
        message.activeJobsCount = 0;
        message.blockedJobsCount = 0;
        message.totalWipValue = 0;
        message.averageOpenJobAgeDays = 0;
        message.calculatedAt = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 open_jobs_count */ 1:
                    message.openJobsCount = reader.int32();
                    break;
                case /* int32 active_jobs_count */ 2:
                    message.activeJobsCount = reader.int32();
                    break;
                case /* int32 blocked_jobs_count */ 3:
                    message.blockedJobsCount = reader.int32();
                    break;
                case /* double total_wip_value */ 4:
                    message.totalWipValue = reader.double();
                    break;
                case /* double average_open_job_age_days */ 5:
                    message.averageOpenJobAgeDays = reader.double();
                    break;
                case /* string calculated_at */ 6:
                    message.calculatedAt = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 open_jobs_count = 1; */
        if (message.openJobsCount !== 0)
            writer.tag(1, WireType.Varint).int32(message.openJobsCount);
        /* int32 active_jobs_count = 2; */
        if (message.activeJobsCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.activeJobsCount);
        /* int32 blocked_jobs_count = 3; */
        if (message.blockedJobsCount !== 0)
            writer.tag(3, WireType.Varint).int32(message.blockedJobsCount);
        /* double total_wip_value = 4; */
        if (message.totalWipValue !== 0)
            writer.tag(4, WireType.Bit64).double(message.totalWipValue);
        /* double average_open_job_age_days = 5; */
        if (message.averageOpenJobAgeDays !== 0)
            writer.tag(5, WireType.Bit64).double(message.averageOpenJobAgeDays);
        /* string calculated_at = 6; */
        if (message.calculatedAt !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.calculatedAt);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.JobProgressKPIsResponse
 */
export const JobProgressKPIsResponse = new JobProgressKPIsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CustomerAccountsOverviewRequest$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.CustomerAccountsOverviewRequest", [
            { no: 1, name: "date_range", kind: "message", T: () => DateRangeFilter },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "search_query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "account_owner_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "sector_filter", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "sort_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "sort_desc", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.pageSize = 0;
        message.pageNumber = 0;
        message.searchQuery = "";
        message.accountOwnerId = 0;
        message.sectorFilter = "";
        message.sortBy = "";
        message.sortDesc = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* kalos.analytics.v1.DateRangeFilter date_range */ 1:
                    message.dateRange = DateRangeFilter.internalBinaryRead(reader, reader.uint32(), options, message.dateRange);
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* int32 page_number */ 3:
                    message.pageNumber = reader.int32();
                    break;
                case /* string search_query */ 4:
                    message.searchQuery = reader.string();
                    break;
                case /* int32 account_owner_id */ 5:
                    message.accountOwnerId = reader.int32();
                    break;
                case /* string sector_filter */ 6:
                    message.sectorFilter = reader.string();
                    break;
                case /* string sort_by */ 7:
                    message.sortBy = reader.string();
                    break;
                case /* bool sort_desc */ 8:
                    message.sortDesc = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* kalos.analytics.v1.DateRangeFilter date_range = 1; */
        if (message.dateRange)
            DateRangeFilter.internalBinaryWrite(message.dateRange, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* int32 page_number = 3; */
        if (message.pageNumber !== 0)
            writer.tag(3, WireType.Varint).int32(message.pageNumber);
        /* string search_query = 4; */
        if (message.searchQuery !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.searchQuery);
        /* int32 account_owner_id = 5; */
        if (message.accountOwnerId !== 0)
            writer.tag(5, WireType.Varint).int32(message.accountOwnerId);
        /* string sector_filter = 6; */
        if (message.sectorFilter !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.sectorFilter);
        /* string sort_by = 7; */
        if (message.sortBy !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.sortBy);
        /* bool sort_desc = 8; */
        if (message.sortDesc !== false)
            writer.tag(8, WireType.Varint).bool(message.sortDesc);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.CustomerAccountsOverviewRequest
 */
export const CustomerAccountsOverviewRequest = new CustomerAccountsOverviewRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CustomerAccountsOverviewResponse$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.CustomerAccountsOverviewResponse", [
            { no: 1, name: "total_accounts", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "total_revenue", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "total_gross_profit", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "total_jobs", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "total_property_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "total_ar_balance", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 7, name: "accounts", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CustomerAccountOverviewRow },
            { no: 8, name: "total_rows", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "calculated_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "managers", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccountManager }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.totalAccounts = 0;
        message.totalRevenue = 0;
        message.totalGrossProfit = 0;
        message.totalJobs = 0;
        message.totalPropertyCount = 0;
        message.totalArBalance = 0;
        message.accounts = [];
        message.totalRows = 0;
        message.calculatedAt = "";
        message.managers = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 total_accounts */ 1:
                    message.totalAccounts = reader.int32();
                    break;
                case /* double total_revenue */ 2:
                    message.totalRevenue = reader.double();
                    break;
                case /* double total_gross_profit */ 3:
                    message.totalGrossProfit = reader.double();
                    break;
                case /* int32 total_jobs */ 4:
                    message.totalJobs = reader.int32();
                    break;
                case /* int32 total_property_count */ 5:
                    message.totalPropertyCount = reader.int32();
                    break;
                case /* double total_ar_balance */ 6:
                    message.totalArBalance = reader.double();
                    break;
                case /* repeated kalos.analytics.v1.CustomerAccountOverviewRow accounts */ 7:
                    message.accounts.push(CustomerAccountOverviewRow.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_rows */ 8:
                    message.totalRows = reader.int32();
                    break;
                case /* string calculated_at */ 9:
                    message.calculatedAt = reader.string();
                    break;
                case /* repeated kalos.analytics.v1.AccountManager managers */ 10:
                    message.managers.push(AccountManager.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 total_accounts = 1; */
        if (message.totalAccounts !== 0)
            writer.tag(1, WireType.Varint).int32(message.totalAccounts);
        /* double total_revenue = 2; */
        if (message.totalRevenue !== 0)
            writer.tag(2, WireType.Bit64).double(message.totalRevenue);
        /* double total_gross_profit = 3; */
        if (message.totalGrossProfit !== 0)
            writer.tag(3, WireType.Bit64).double(message.totalGrossProfit);
        /* int32 total_jobs = 4; */
        if (message.totalJobs !== 0)
            writer.tag(4, WireType.Varint).int32(message.totalJobs);
        /* int32 total_property_count = 5; */
        if (message.totalPropertyCount !== 0)
            writer.tag(5, WireType.Varint).int32(message.totalPropertyCount);
        /* double total_ar_balance = 6; */
        if (message.totalArBalance !== 0)
            writer.tag(6, WireType.Bit64).double(message.totalArBalance);
        /* repeated kalos.analytics.v1.CustomerAccountOverviewRow accounts = 7; */
        for (let i = 0; i < message.accounts.length; i++)
            CustomerAccountOverviewRow.internalBinaryWrite(message.accounts[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_rows = 8; */
        if (message.totalRows !== 0)
            writer.tag(8, WireType.Varint).int32(message.totalRows);
        /* string calculated_at = 9; */
        if (message.calculatedAt !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.calculatedAt);
        /* repeated kalos.analytics.v1.AccountManager managers = 10; */
        for (let i = 0; i < message.managers.length; i++)
            AccountManager.internalBinaryWrite(message.managers[i], writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.CustomerAccountsOverviewResponse
 */
export const CustomerAccountsOverviewResponse = new CustomerAccountsOverviewResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccountManager$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.AccountManager", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.name = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.AccountManager
 */
export const AccountManager = new AccountManager$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CustomerAccountOverviewRow$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.CustomerAccountOverviewRow", [
            { no: 1, name: "customer_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "customer_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "business_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "total_revenue", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "gross_profit", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "margin_percentage", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 7, name: "total_jobs", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "profitable_jobs", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "losing_jobs", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "callback_percentage", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 11, name: "property_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 12, name: "account_owner_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 13, name: "account_owner_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "sector", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "ar_balance", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.customerId = 0;
        message.customerName = "";
        message.businessName = "";
        message.totalRevenue = 0;
        message.grossProfit = 0;
        message.marginPercentage = 0;
        message.totalJobs = 0;
        message.profitableJobs = 0;
        message.losingJobs = 0;
        message.callbackPercentage = 0;
        message.propertyCount = 0;
        message.accountOwnerId = 0;
        message.accountOwnerName = "";
        message.sector = "";
        message.arBalance = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 customer_id */ 1:
                    message.customerId = reader.int32();
                    break;
                case /* string customer_name */ 2:
                    message.customerName = reader.string();
                    break;
                case /* string business_name */ 3:
                    message.businessName = reader.string();
                    break;
                case /* double total_revenue */ 4:
                    message.totalRevenue = reader.double();
                    break;
                case /* double gross_profit */ 5:
                    message.grossProfit = reader.double();
                    break;
                case /* double margin_percentage */ 6:
                    message.marginPercentage = reader.double();
                    break;
                case /* int32 total_jobs */ 7:
                    message.totalJobs = reader.int32();
                    break;
                case /* int32 profitable_jobs */ 8:
                    message.profitableJobs = reader.int32();
                    break;
                case /* int32 losing_jobs */ 9:
                    message.losingJobs = reader.int32();
                    break;
                case /* double callback_percentage */ 10:
                    message.callbackPercentage = reader.double();
                    break;
                case /* int32 property_count */ 11:
                    message.propertyCount = reader.int32();
                    break;
                case /* int32 account_owner_id */ 12:
                    message.accountOwnerId = reader.int32();
                    break;
                case /* string account_owner_name */ 13:
                    message.accountOwnerName = reader.string();
                    break;
                case /* string sector */ 14:
                    message.sector = reader.string();
                    break;
                case /* double ar_balance */ 15:
                    message.arBalance = reader.double();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 customer_id = 1; */
        if (message.customerId !== 0)
            writer.tag(1, WireType.Varint).int32(message.customerId);
        /* string customer_name = 2; */
        if (message.customerName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.customerName);
        /* string business_name = 3; */
        if (message.businessName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.businessName);
        /* double total_revenue = 4; */
        if (message.totalRevenue !== 0)
            writer.tag(4, WireType.Bit64).double(message.totalRevenue);
        /* double gross_profit = 5; */
        if (message.grossProfit !== 0)
            writer.tag(5, WireType.Bit64).double(message.grossProfit);
        /* double margin_percentage = 6; */
        if (message.marginPercentage !== 0)
            writer.tag(6, WireType.Bit64).double(message.marginPercentage);
        /* int32 total_jobs = 7; */
        if (message.totalJobs !== 0)
            writer.tag(7, WireType.Varint).int32(message.totalJobs);
        /* int32 profitable_jobs = 8; */
        if (message.profitableJobs !== 0)
            writer.tag(8, WireType.Varint).int32(message.profitableJobs);
        /* int32 losing_jobs = 9; */
        if (message.losingJobs !== 0)
            writer.tag(9, WireType.Varint).int32(message.losingJobs);
        /* double callback_percentage = 10; */
        if (message.callbackPercentage !== 0)
            writer.tag(10, WireType.Bit64).double(message.callbackPercentage);
        /* int32 property_count = 11; */
        if (message.propertyCount !== 0)
            writer.tag(11, WireType.Varint).int32(message.propertyCount);
        /* int32 account_owner_id = 12; */
        if (message.accountOwnerId !== 0)
            writer.tag(12, WireType.Varint).int32(message.accountOwnerId);
        /* string account_owner_name = 13; */
        if (message.accountOwnerName !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.accountOwnerName);
        /* string sector = 14; */
        if (message.sector !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.sector);
        /* double ar_balance = 15; */
        if (message.arBalance !== 0)
            writer.tag(15, WireType.Bit64).double(message.arBalance);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.CustomerAccountOverviewRow
 */
export const CustomerAccountOverviewRow = new CustomerAccountOverviewRow$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListCallbackEventsRequest$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.ListCallbackEventsRequest", [
            { no: 1, name: "filter", kind: "message", T: () => StandardMetricsFilter },
            { no: 2, name: "pagination", kind: "message", T: () => PaginationRequest }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* kalos.analytics.v1.StandardMetricsFilter filter */ 1:
                    message.filter = StandardMetricsFilter.internalBinaryRead(reader, reader.uint32(), options, message.filter);
                    break;
                case /* kalos.analytics.v1.PaginationRequest pagination */ 2:
                    message.pagination = PaginationRequest.internalBinaryRead(reader, reader.uint32(), options, message.pagination);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* kalos.analytics.v1.StandardMetricsFilter filter = 1; */
        if (message.filter)
            StandardMetricsFilter.internalBinaryWrite(message.filter, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* kalos.analytics.v1.PaginationRequest pagination = 2; */
        if (message.pagination)
            PaginationRequest.internalBinaryWrite(message.pagination, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.ListCallbackEventsRequest
 */
export const ListCallbackEventsRequest = new ListCallbackEventsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListCallbackEventsResponse$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.ListCallbackEventsResponse", [
            { no: 1, name: "events", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CallbackEventItem },
            { no: 2, name: "pagination", kind: "message", T: () => PaginationResponse }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.events = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated kalos.analytics.v1.CallbackEventItem events */ 1:
                    message.events.push(CallbackEventItem.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* kalos.analytics.v1.PaginationResponse pagination */ 2:
                    message.pagination = PaginationResponse.internalBinaryRead(reader, reader.uint32(), options, message.pagination);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated kalos.analytics.v1.CallbackEventItem events = 1; */
        for (let i = 0; i < message.events.length; i++)
            CallbackEventItem.internalBinaryWrite(message.events[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* kalos.analytics.v1.PaginationResponse pagination = 2; */
        if (message.pagination)
            PaginationResponse.internalBinaryWrite(message.pagination, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.ListCallbackEventsResponse
 */
export const ListCallbackEventsResponse = new ListCallbackEventsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CallbackEventItem$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.CallbackEventItem", [
            { no: 1, name: "event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "property_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "department_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "job_type_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "job_subtype_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "log_job_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "log_date_completed", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "log_technician_assigned", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "callback_disposition", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "callback_comments", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "callback_original_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 12, name: "callback_technician", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 13, name: "is_callback", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 14, name: "is_lmpc", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.eventId = 0;
        message.propertyId = 0;
        message.departmentId = 0;
        message.jobTypeId = 0;
        message.jobSubtypeId = 0;
        message.logJobNumber = "";
        message.logDateCompleted = "";
        message.logTechnicianAssigned = "";
        message.callbackDisposition = 0;
        message.callbackComments = "";
        message.callbackOriginalId = 0;
        message.callbackTechnician = 0;
        message.isCallback = 0;
        message.isLmpc = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 event_id */ 1:
                    message.eventId = reader.int32();
                    break;
                case /* int32 property_id */ 2:
                    message.propertyId = reader.int32();
                    break;
                case /* int32 department_id */ 3:
                    message.departmentId = reader.int32();
                    break;
                case /* int32 job_type_id */ 4:
                    message.jobTypeId = reader.int32();
                    break;
                case /* int32 job_subtype_id */ 5:
                    message.jobSubtypeId = reader.int32();
                    break;
                case /* string log_job_number */ 6:
                    message.logJobNumber = reader.string();
                    break;
                case /* string log_date_completed */ 7:
                    message.logDateCompleted = reader.string();
                    break;
                case /* string log_technician_assigned */ 8:
                    message.logTechnicianAssigned = reader.string();
                    break;
                case /* int32 callback_disposition */ 9:
                    message.callbackDisposition = reader.int32();
                    break;
                case /* string callback_comments */ 10:
                    message.callbackComments = reader.string();
                    break;
                case /* int32 callback_original_id */ 11:
                    message.callbackOriginalId = reader.int32();
                    break;
                case /* int32 callback_technician */ 12:
                    message.callbackTechnician = reader.int32();
                    break;
                case /* int32 is_callback */ 13:
                    message.isCallback = reader.int32();
                    break;
                case /* int32 is_lmpc */ 14:
                    message.isLmpc = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 event_id = 1; */
        if (message.eventId !== 0)
            writer.tag(1, WireType.Varint).int32(message.eventId);
        /* int32 property_id = 2; */
        if (message.propertyId !== 0)
            writer.tag(2, WireType.Varint).int32(message.propertyId);
        /* int32 department_id = 3; */
        if (message.departmentId !== 0)
            writer.tag(3, WireType.Varint).int32(message.departmentId);
        /* int32 job_type_id = 4; */
        if (message.jobTypeId !== 0)
            writer.tag(4, WireType.Varint).int32(message.jobTypeId);
        /* int32 job_subtype_id = 5; */
        if (message.jobSubtypeId !== 0)
            writer.tag(5, WireType.Varint).int32(message.jobSubtypeId);
        /* string log_job_number = 6; */
        if (message.logJobNumber !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.logJobNumber);
        /* string log_date_completed = 7; */
        if (message.logDateCompleted !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.logDateCompleted);
        /* string log_technician_assigned = 8; */
        if (message.logTechnicianAssigned !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.logTechnicianAssigned);
        /* int32 callback_disposition = 9; */
        if (message.callbackDisposition !== 0)
            writer.tag(9, WireType.Varint).int32(message.callbackDisposition);
        /* string callback_comments = 10; */
        if (message.callbackComments !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.callbackComments);
        /* int32 callback_original_id = 11; */
        if (message.callbackOriginalId !== 0)
            writer.tag(11, WireType.Varint).int32(message.callbackOriginalId);
        /* int32 callback_technician = 12; */
        if (message.callbackTechnician !== 0)
            writer.tag(12, WireType.Varint).int32(message.callbackTechnician);
        /* int32 is_callback = 13; */
        if (message.isCallback !== 0)
            writer.tag(13, WireType.Varint).int32(message.isCallback);
        /* int32 is_lmpc = 14; */
        if (message.isLmpc !== 0)
            writer.tag(14, WireType.Varint).int32(message.isLmpc);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.CallbackEventItem
 */
export const CallbackEventItem = new CallbackEventItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListPricingSellSheetsRequest$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.ListPricingSellSheetsRequest", [
            { no: 1, name: "filter", kind: "message", T: () => StandardMetricsFilter },
            { no: 2, name: "pagination", kind: "message", T: () => PaginationRequest }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* kalos.analytics.v1.StandardMetricsFilter filter */ 1:
                    message.filter = StandardMetricsFilter.internalBinaryRead(reader, reader.uint32(), options, message.filter);
                    break;
                case /* kalos.analytics.v1.PaginationRequest pagination */ 2:
                    message.pagination = PaginationRequest.internalBinaryRead(reader, reader.uint32(), options, message.pagination);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* kalos.analytics.v1.StandardMetricsFilter filter = 1; */
        if (message.filter)
            StandardMetricsFilter.internalBinaryWrite(message.filter, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* kalos.analytics.v1.PaginationRequest pagination = 2; */
        if (message.pagination)
            PaginationRequest.internalBinaryWrite(message.pagination, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.ListPricingSellSheetsRequest
 */
export const ListPricingSellSheetsRequest = new ListPricingSellSheetsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListPricingSellSheetsResponse$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.ListPricingSellSheetsResponse", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SellSheet },
            { no: 2, name: "pagination", kind: "message", T: () => PaginationResponse }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated SellSheet results */ 1:
                    message.results.push(SellSheet.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* kalos.analytics.v1.PaginationResponse pagination */ 2:
                    message.pagination = PaginationResponse.internalBinaryRead(reader, reader.uint32(), options, message.pagination);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated SellSheet results = 1; */
        for (let i = 0; i < message.results.length; i++)
            SellSheet.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* kalos.analytics.v1.PaginationResponse pagination = 2; */
        if (message.pagination)
            PaginationResponse.internalBinaryWrite(message.pagination, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.ListPricingSellSheetsResponse
 */
export const ListPricingSellSheetsResponse = new ListPricingSellSheetsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MembershipSalesFilter$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.MembershipSalesFilter", [
            { no: 1, name: "date_range", kind: "message", T: () => DateRangeFilter },
            { no: 2, name: "sold_by_user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "membership_type_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "is_residential", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "is_commercial", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "sale_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "sale_status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "plan_program", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "plan_tier", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.soldByUserId = 0;
        message.membershipTypeId = 0;
        message.isResidential = false;
        message.isCommercial = false;
        message.saleType = "";
        message.saleStatus = "";
        message.planProgram = "";
        message.planTier = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* kalos.analytics.v1.DateRangeFilter date_range */ 1:
                    message.dateRange = DateRangeFilter.internalBinaryRead(reader, reader.uint32(), options, message.dateRange);
                    break;
                case /* int32 sold_by_user_id */ 2:
                    message.soldByUserId = reader.int32();
                    break;
                case /* int32 membership_type_id */ 3:
                    message.membershipTypeId = reader.int32();
                    break;
                case /* bool is_residential */ 4:
                    message.isResidential = reader.bool();
                    break;
                case /* bool is_commercial */ 5:
                    message.isCommercial = reader.bool();
                    break;
                case /* string sale_type */ 6:
                    message.saleType = reader.string();
                    break;
                case /* string sale_status */ 7:
                    message.saleStatus = reader.string();
                    break;
                case /* string plan_program */ 8:
                    message.planProgram = reader.string();
                    break;
                case /* string plan_tier */ 9:
                    message.planTier = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* kalos.analytics.v1.DateRangeFilter date_range = 1; */
        if (message.dateRange)
            DateRangeFilter.internalBinaryWrite(message.dateRange, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 sold_by_user_id = 2; */
        if (message.soldByUserId !== 0)
            writer.tag(2, WireType.Varint).int32(message.soldByUserId);
        /* int32 membership_type_id = 3; */
        if (message.membershipTypeId !== 0)
            writer.tag(3, WireType.Varint).int32(message.membershipTypeId);
        /* bool is_residential = 4; */
        if (message.isResidential !== false)
            writer.tag(4, WireType.Varint).bool(message.isResidential);
        /* bool is_commercial = 5; */
        if (message.isCommercial !== false)
            writer.tag(5, WireType.Varint).bool(message.isCommercial);
        /* string sale_type = 6; */
        if (message.saleType !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.saleType);
        /* string sale_status = 7; */
        if (message.saleStatus !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.saleStatus);
        /* string plan_program = 8; */
        if (message.planProgram !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.planProgram);
        /* string plan_tier = 9; */
        if (message.planTier !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.planTier);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.MembershipSalesFilter
 */
export const MembershipSalesFilter = new MembershipSalesFilter$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetMembershipSalesMetricsRequest$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.GetMembershipSalesMetricsRequest", [
            { no: 1, name: "filter", kind: "message", T: () => MembershipSalesFilter }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* kalos.analytics.v1.MembershipSalesFilter filter */ 1:
                    message.filter = MembershipSalesFilter.internalBinaryRead(reader, reader.uint32(), options, message.filter);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* kalos.analytics.v1.MembershipSalesFilter filter = 1; */
        if (message.filter)
            MembershipSalesFilter.internalBinaryWrite(message.filter, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.GetMembershipSalesMetricsRequest
 */
export const GetMembershipSalesMetricsRequest = new GetMembershipSalesMetricsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MembershipSalesMetricsResponse$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.MembershipSalesMetricsResponse", [
            { no: 1, name: "total_sales", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "new_sales", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "renewal_sales", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "active_sales", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "pending_sales", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "cancelled_sales", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "total_amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 8, name: "average_amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 9, name: "sellers", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => MembershipSalesBySeller },
            { no: 10, name: "outlook", kind: "message", T: () => MembershipRenewalOutlook },
            { no: 11, name: "calculated_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.totalSales = 0;
        message.newSales = 0;
        message.renewalSales = 0;
        message.activeSales = 0;
        message.pendingSales = 0;
        message.cancelledSales = 0;
        message.totalAmount = 0;
        message.averageAmount = 0;
        message.sellers = [];
        message.calculatedAt = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 total_sales */ 1:
                    message.totalSales = reader.int32();
                    break;
                case /* int32 new_sales */ 2:
                    message.newSales = reader.int32();
                    break;
                case /* int32 renewal_sales */ 3:
                    message.renewalSales = reader.int32();
                    break;
                case /* int32 active_sales */ 4:
                    message.activeSales = reader.int32();
                    break;
                case /* int32 pending_sales */ 5:
                    message.pendingSales = reader.int32();
                    break;
                case /* int32 cancelled_sales */ 6:
                    message.cancelledSales = reader.int32();
                    break;
                case /* double total_amount */ 7:
                    message.totalAmount = reader.double();
                    break;
                case /* double average_amount */ 8:
                    message.averageAmount = reader.double();
                    break;
                case /* repeated kalos.analytics.v1.MembershipSalesBySeller sellers */ 9:
                    message.sellers.push(MembershipSalesBySeller.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* kalos.analytics.v1.MembershipRenewalOutlook outlook */ 10:
                    message.outlook = MembershipRenewalOutlook.internalBinaryRead(reader, reader.uint32(), options, message.outlook);
                    break;
                case /* string calculated_at */ 11:
                    message.calculatedAt = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 total_sales = 1; */
        if (message.totalSales !== 0)
            writer.tag(1, WireType.Varint).int32(message.totalSales);
        /* int32 new_sales = 2; */
        if (message.newSales !== 0)
            writer.tag(2, WireType.Varint).int32(message.newSales);
        /* int32 renewal_sales = 3; */
        if (message.renewalSales !== 0)
            writer.tag(3, WireType.Varint).int32(message.renewalSales);
        /* int32 active_sales = 4; */
        if (message.activeSales !== 0)
            writer.tag(4, WireType.Varint).int32(message.activeSales);
        /* int32 pending_sales = 5; */
        if (message.pendingSales !== 0)
            writer.tag(5, WireType.Varint).int32(message.pendingSales);
        /* int32 cancelled_sales = 6; */
        if (message.cancelledSales !== 0)
            writer.tag(6, WireType.Varint).int32(message.cancelledSales);
        /* double total_amount = 7; */
        if (message.totalAmount !== 0)
            writer.tag(7, WireType.Bit64).double(message.totalAmount);
        /* double average_amount = 8; */
        if (message.averageAmount !== 0)
            writer.tag(8, WireType.Bit64).double(message.averageAmount);
        /* repeated kalos.analytics.v1.MembershipSalesBySeller sellers = 9; */
        for (let i = 0; i < message.sellers.length; i++)
            MembershipSalesBySeller.internalBinaryWrite(message.sellers[i], writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* kalos.analytics.v1.MembershipRenewalOutlook outlook = 10; */
        if (message.outlook)
            MembershipRenewalOutlook.internalBinaryWrite(message.outlook, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* string calculated_at = 11; */
        if (message.calculatedAt !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.calculatedAt);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.MembershipSalesMetricsResponse
 */
export const MembershipSalesMetricsResponse = new MembershipSalesMetricsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MembershipSalesBySeller$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.MembershipSalesBySeller", [
            { no: 1, name: "sold_by_user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "sold_by_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "is_contractor", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "new_sales", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "renewal_sales", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "total_sales", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "total_amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 8, name: "pending_sales", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "plan_sales", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => MembershipSalesPlanCount }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.soldByUserId = 0;
        message.soldByName = "";
        message.isContractor = false;
        message.newSales = 0;
        message.renewalSales = 0;
        message.totalSales = 0;
        message.totalAmount = 0;
        message.pendingSales = 0;
        message.planSales = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 sold_by_user_id */ 1:
                    message.soldByUserId = reader.int32();
                    break;
                case /* string sold_by_name */ 2:
                    message.soldByName = reader.string();
                    break;
                case /* bool is_contractor */ 3:
                    message.isContractor = reader.bool();
                    break;
                case /* int32 new_sales */ 4:
                    message.newSales = reader.int32();
                    break;
                case /* int32 renewal_sales */ 5:
                    message.renewalSales = reader.int32();
                    break;
                case /* int32 total_sales */ 6:
                    message.totalSales = reader.int32();
                    break;
                case /* double total_amount */ 7:
                    message.totalAmount = reader.double();
                    break;
                case /* int32 pending_sales */ 8:
                    message.pendingSales = reader.int32();
                    break;
                case /* repeated kalos.analytics.v1.MembershipSalesPlanCount plan_sales */ 9:
                    message.planSales.push(MembershipSalesPlanCount.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 sold_by_user_id = 1; */
        if (message.soldByUserId !== 0)
            writer.tag(1, WireType.Varint).int32(message.soldByUserId);
        /* string sold_by_name = 2; */
        if (message.soldByName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.soldByName);
        /* bool is_contractor = 3; */
        if (message.isContractor !== false)
            writer.tag(3, WireType.Varint).bool(message.isContractor);
        /* int32 new_sales = 4; */
        if (message.newSales !== 0)
            writer.tag(4, WireType.Varint).int32(message.newSales);
        /* int32 renewal_sales = 5; */
        if (message.renewalSales !== 0)
            writer.tag(5, WireType.Varint).int32(message.renewalSales);
        /* int32 total_sales = 6; */
        if (message.totalSales !== 0)
            writer.tag(6, WireType.Varint).int32(message.totalSales);
        /* double total_amount = 7; */
        if (message.totalAmount !== 0)
            writer.tag(7, WireType.Bit64).double(message.totalAmount);
        /* int32 pending_sales = 8; */
        if (message.pendingSales !== 0)
            writer.tag(8, WireType.Varint).int32(message.pendingSales);
        /* repeated kalos.analytics.v1.MembershipSalesPlanCount plan_sales = 9; */
        for (let i = 0; i < message.planSales.length; i++)
            MembershipSalesPlanCount.internalBinaryWrite(message.planSales[i], writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.MembershipSalesBySeller
 */
export const MembershipSalesBySeller = new MembershipSalesBySeller$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MembershipSalesPlanCount$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.MembershipSalesPlanCount", [
            { no: 1, name: "program", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "tier", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "sales", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.program = "";
        message.tier = "";
        message.sales = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string program */ 1:
                    message.program = reader.string();
                    break;
                case /* string tier */ 2:
                    message.tier = reader.string();
                    break;
                case /* int32 sales */ 3:
                    message.sales = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string program = 1; */
        if (message.program !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.program);
        /* string tier = 2; */
        if (message.tier !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.tier);
        /* int32 sales = 3; */
        if (message.sales !== 0)
            writer.tag(3, WireType.Varint).int32(message.sales);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.MembershipSalesPlanCount
 */
export const MembershipSalesPlanCount = new MembershipSalesPlanCount$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MembershipRenewalOutlook$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.MembershipRenewalOutlook", [
            { no: 1, name: "terms_ending", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "renewed", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "not_yet_renewed", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "cancelled", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "scheduled_cancel", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "payment_pending", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.termsEnding = 0;
        message.renewed = 0;
        message.notYetRenewed = 0;
        message.cancelled = 0;
        message.scheduledCancel = 0;
        message.paymentPending = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 terms_ending */ 1:
                    message.termsEnding = reader.int32();
                    break;
                case /* int32 renewed */ 2:
                    message.renewed = reader.int32();
                    break;
                case /* int32 not_yet_renewed */ 3:
                    message.notYetRenewed = reader.int32();
                    break;
                case /* int32 cancelled */ 4:
                    message.cancelled = reader.int32();
                    break;
                case /* int32 scheduled_cancel */ 5:
                    message.scheduledCancel = reader.int32();
                    break;
                case /* int32 payment_pending */ 6:
                    message.paymentPending = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 terms_ending = 1; */
        if (message.termsEnding !== 0)
            writer.tag(1, WireType.Varint).int32(message.termsEnding);
        /* int32 renewed = 2; */
        if (message.renewed !== 0)
            writer.tag(2, WireType.Varint).int32(message.renewed);
        /* int32 not_yet_renewed = 3; */
        if (message.notYetRenewed !== 0)
            writer.tag(3, WireType.Varint).int32(message.notYetRenewed);
        /* int32 cancelled = 4; */
        if (message.cancelled !== 0)
            writer.tag(4, WireType.Varint).int32(message.cancelled);
        /* int32 scheduled_cancel = 5; */
        if (message.scheduledCancel !== 0)
            writer.tag(5, WireType.Varint).int32(message.scheduledCancel);
        /* int32 payment_pending = 6; */
        if (message.paymentPending !== 0)
            writer.tag(6, WireType.Varint).int32(message.paymentPending);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.MembershipRenewalOutlook
 */
export const MembershipRenewalOutlook = new MembershipRenewalOutlook$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListMembershipSalesRequest$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.ListMembershipSalesRequest", [
            { no: 1, name: "filter", kind: "message", T: () => MembershipSalesFilter },
            { no: 2, name: "pagination", kind: "message", T: () => PaginationRequest }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* kalos.analytics.v1.MembershipSalesFilter filter */ 1:
                    message.filter = MembershipSalesFilter.internalBinaryRead(reader, reader.uint32(), options, message.filter);
                    break;
                case /* kalos.analytics.v1.PaginationRequest pagination */ 2:
                    message.pagination = PaginationRequest.internalBinaryRead(reader, reader.uint32(), options, message.pagination);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* kalos.analytics.v1.MembershipSalesFilter filter = 1; */
        if (message.filter)
            MembershipSalesFilter.internalBinaryWrite(message.filter, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* kalos.analytics.v1.PaginationRequest pagination = 2; */
        if (message.pagination)
            PaginationRequest.internalBinaryWrite(message.pagination, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.ListMembershipSalesRequest
 */
export const ListMembershipSalesRequest = new ListMembershipSalesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListMembershipSalesResponse$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.ListMembershipSalesResponse", [
            { no: 1, name: "sales", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => MembershipSaleRow },
            { no: 2, name: "pagination", kind: "message", T: () => PaginationResponse }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.sales = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated kalos.analytics.v1.MembershipSaleRow sales */ 1:
                    message.sales.push(MembershipSaleRow.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* kalos.analytics.v1.PaginationResponse pagination */ 2:
                    message.pagination = PaginationResponse.internalBinaryRead(reader, reader.uint32(), options, message.pagination);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated kalos.analytics.v1.MembershipSaleRow sales = 1; */
        for (let i = 0; i < message.sales.length; i++)
            MembershipSaleRow.internalBinaryWrite(message.sales[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* kalos.analytics.v1.PaginationResponse pagination = 2; */
        if (message.pagination)
            PaginationResponse.internalBinaryWrite(message.pagination, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.ListMembershipSalesResponse
 */
export const ListMembershipSalesResponse = new ListMembershipSalesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MembershipSaleRow$Type extends MessageType {
    constructor() {
        super("kalos.analytics.v1.MembershipSaleRow", [
            { no: 1, name: "membership_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "contract_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "contract_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "sale_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "plan_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "is_commercial", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "customer_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "customer_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "business_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "property_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "property_address", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "sold_by_user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 13, name: "sold_by_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "sold_by_is_contractor", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 15, name: "amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 16, name: "status_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 17, name: "payment_status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 18, name: "review_status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 19, name: "date_started", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 20, name: "date_ended", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 21, name: "sold_on_event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 22, name: "is_renewal", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 23, name: "sale_status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 24, name: "status", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.membershipId = 0;
        message.contractId = 0;
        message.contractNumber = "";
        message.saleDate = "";
        message.planName = "";
        message.isCommercial = false;
        message.customerId = 0;
        message.customerName = "";
        message.businessName = "";
        message.propertyId = 0;
        message.propertyAddress = "";
        message.soldByUserId = 0;
        message.soldByName = "";
        message.soldByIsContractor = false;
        message.amount = 0;
        message.statusId = 0;
        message.paymentStatus = "";
        message.reviewStatus = "";
        message.dateStarted = "";
        message.dateEnded = "";
        message.soldOnEventId = 0;
        message.isRenewal = false;
        message.saleStatus = "";
        message.status = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 membership_id */ 1:
                    message.membershipId = reader.int32();
                    break;
                case /* int32 contract_id */ 2:
                    message.contractId = reader.int32();
                    break;
                case /* string contract_number */ 3:
                    message.contractNumber = reader.string();
                    break;
                case /* string sale_date */ 4:
                    message.saleDate = reader.string();
                    break;
                case /* string plan_name */ 5:
                    message.planName = reader.string();
                    break;
                case /* bool is_commercial */ 6:
                    message.isCommercial = reader.bool();
                    break;
                case /* int32 customer_id */ 7:
                    message.customerId = reader.int32();
                    break;
                case /* string customer_name */ 8:
                    message.customerName = reader.string();
                    break;
                case /* string business_name */ 9:
                    message.businessName = reader.string();
                    break;
                case /* int32 property_id */ 10:
                    message.propertyId = reader.int32();
                    break;
                case /* string property_address */ 11:
                    message.propertyAddress = reader.string();
                    break;
                case /* int32 sold_by_user_id */ 12:
                    message.soldByUserId = reader.int32();
                    break;
                case /* string sold_by_name */ 13:
                    message.soldByName = reader.string();
                    break;
                case /* bool sold_by_is_contractor */ 14:
                    message.soldByIsContractor = reader.bool();
                    break;
                case /* double amount */ 15:
                    message.amount = reader.double();
                    break;
                case /* int32 status_id */ 16:
                    message.statusId = reader.int32();
                    break;
                case /* string payment_status */ 17:
                    message.paymentStatus = reader.string();
                    break;
                case /* string review_status */ 18:
                    message.reviewStatus = reader.string();
                    break;
                case /* string date_started */ 19:
                    message.dateStarted = reader.string();
                    break;
                case /* string date_ended */ 20:
                    message.dateEnded = reader.string();
                    break;
                case /* int32 sold_on_event_id */ 21:
                    message.soldOnEventId = reader.int32();
                    break;
                case /* bool is_renewal */ 22:
                    message.isRenewal = reader.bool();
                    break;
                case /* string sale_status */ 23:
                    message.saleStatus = reader.string();
                    break;
                case /* string status */ 24:
                    message.status = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 membership_id = 1; */
        if (message.membershipId !== 0)
            writer.tag(1, WireType.Varint).int32(message.membershipId);
        /* int32 contract_id = 2; */
        if (message.contractId !== 0)
            writer.tag(2, WireType.Varint).int32(message.contractId);
        /* string contract_number = 3; */
        if (message.contractNumber !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.contractNumber);
        /* string sale_date = 4; */
        if (message.saleDate !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.saleDate);
        /* string plan_name = 5; */
        if (message.planName !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.planName);
        /* bool is_commercial = 6; */
        if (message.isCommercial !== false)
            writer.tag(6, WireType.Varint).bool(message.isCommercial);
        /* int32 customer_id = 7; */
        if (message.customerId !== 0)
            writer.tag(7, WireType.Varint).int32(message.customerId);
        /* string customer_name = 8; */
        if (message.customerName !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.customerName);
        /* string business_name = 9; */
        if (message.businessName !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.businessName);
        /* int32 property_id = 10; */
        if (message.propertyId !== 0)
            writer.tag(10, WireType.Varint).int32(message.propertyId);
        /* string property_address = 11; */
        if (message.propertyAddress !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.propertyAddress);
        /* int32 sold_by_user_id = 12; */
        if (message.soldByUserId !== 0)
            writer.tag(12, WireType.Varint).int32(message.soldByUserId);
        /* string sold_by_name = 13; */
        if (message.soldByName !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.soldByName);
        /* bool sold_by_is_contractor = 14; */
        if (message.soldByIsContractor !== false)
            writer.tag(14, WireType.Varint).bool(message.soldByIsContractor);
        /* double amount = 15; */
        if (message.amount !== 0)
            writer.tag(15, WireType.Bit64).double(message.amount);
        /* int32 status_id = 16; */
        if (message.statusId !== 0)
            writer.tag(16, WireType.Varint).int32(message.statusId);
        /* string payment_status = 17; */
        if (message.paymentStatus !== "")
            writer.tag(17, WireType.LengthDelimited).string(message.paymentStatus);
        /* string review_status = 18; */
        if (message.reviewStatus !== "")
            writer.tag(18, WireType.LengthDelimited).string(message.reviewStatus);
        /* string date_started = 19; */
        if (message.dateStarted !== "")
            writer.tag(19, WireType.LengthDelimited).string(message.dateStarted);
        /* string date_ended = 20; */
        if (message.dateEnded !== "")
            writer.tag(20, WireType.LengthDelimited).string(message.dateEnded);
        /* int32 sold_on_event_id = 21; */
        if (message.soldOnEventId !== 0)
            writer.tag(21, WireType.Varint).int32(message.soldOnEventId);
        /* bool is_renewal = 22; */
        if (message.isRenewal !== false)
            writer.tag(22, WireType.Varint).bool(message.isRenewal);
        /* string sale_status = 23; */
        if (message.saleStatus !== "")
            writer.tag(23, WireType.LengthDelimited).string(message.saleStatus);
        /* string status = 24; */
        if (message.status !== "")
            writer.tag(24, WireType.LengthDelimited).string(message.status);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message kalos.analytics.v1.MembershipSaleRow
 */
export const MembershipSaleRow = new MembershipSaleRow$Type();
/**
 * @generated ServiceType for protobuf service kalos.analytics.v1.AnalyticsService
 */
export const AnalyticsService = new ServiceType("kalos.analytics.v1.AnalyticsService", [
    { name: "GetFinancialPerformanceMetrics", options: {}, I: FinancialPerformanceMetricsRequest, O: FinancialPerformanceMetricsResponse },
    { name: "GetPricingMetrics", options: {}, I: PricingMetricsRequest, O: PricingMetricsResponse },
    { name: "GetJobProfitability", options: {}, I: JobProfitabilityRequest, O: JobProfitabilityResponse },
    { name: "GetServiceQualityMetrics", options: {}, I: ServiceQualityMetricsRequest, O: ServiceQualityMetricsResponse },
    { name: "GetTechnicianCallbackAnalysis", options: {}, I: TechnicianCallbackAnalysisRequest, O: TechnicianCallbackAnalysisResponse },
    { name: "GetTechnicianPerformance", options: {}, I: TechnicianPerformanceRequest, O: TechnicianPerformanceResponse },
    { name: "GetTechnicianPerformanceDetail", options: {}, I: TechnicianPerformanceDetailRequest, O: TechnicianPerformanceDetailResponse },
    { name: "GetBlockedJobs", options: {}, I: BlockedJobsRequest, O: BlockedJobsResponse },
    { name: "GetJobStatusBreakdown", options: {}, I: JobStatusBreakdownRequest, O: JobStatusBreakdownResponse },
    { name: "GetJobProgressKPIs", options: {}, I: JobProgressKPIsRequest, O: JobProgressKPIsResponse },
    { name: "GetCustomerAccountsOverview", options: {}, I: CustomerAccountsOverviewRequest, O: CustomerAccountsOverviewResponse },
    { name: "ListCallbackEvents", options: {}, I: ListCallbackEventsRequest, O: ListCallbackEventsResponse },
    { name: "ListPricingSellSheets", options: {}, I: ListPricingSellSheetsRequest, O: ListPricingSellSheetsResponse },
    { name: "GetMembershipSalesMetrics", options: {}, I: GetMembershipSalesMetricsRequest, O: MembershipSalesMetricsResponse },
    { name: "ListMembershipSales", options: {}, I: ListMembershipSalesRequest, O: ListMembershipSalesResponse }
]);
